import { serviceIcons } from '@assets/icons/services';
import config from 'react-global-configuration';
import { Trans } from 'react-i18next';
import React from 'react';

export const INCLUDED_SERVICES = new Set(config.get('includedServices') || []);
export const ALL_SERVICES_INCLUDED = INCLUDED_SERVICES.size === 0;

export const PHONE_INPUT_FIELDS = ['phone', 'phone_1', 'phone_2', 'phone_3', 'phone_number'];
const EMAIL_INPUT_FIELDS = ['email', 'email_1', 'email_2', 'email_3', 'email_address'];
const COMPANY_NAME_INPUT_FIELDS = [
  'company_name', 'business_name', 'organization_name', 'biz_name', 'legal_name',
  'company', 'business', 'organization', 'name',
];
export const DOMAIN_INPUT_FIELDS = ['site', 'domain', 'website'];
const DOMAINS_SERVICE_OUTPUT_FIELDS = [
  'email_1', 'email_1_full_name', 'email_1_first_name', 'email_1_last_name', 'email_1_title', 'email_1_phone',
  'email_2', 'email_2_full_name', 'email_2_first_name', 'email_2_last_name', 'email_2_title', 'email_2_phone',
  'email_3', 'email_3_full_name', 'email_3_first_name', 'email_3_last_name', 'email_3_title', 'email_3_phone',
  'phone_1', 'phone_2', 'phone_3',
  'facebook', 'instagram', 'linkedin', 'tiktok', 'medium', 'reddit', 'skype', 'snapchat', 'telegram', 'whatsapp', 'twitter', 'vimeo', 'youtube', 'github', 'crunchbase',
  'website_title', 'website_generator', 'website_description', 'website_keywords', 'website_has_fb_pixel', 'website_has_google_tag',
];
export const QUERY_LABEL_KEYS = Object.freeze({
  APPS_MOVIES_BOOKS_LINKS_OR_IDS: 'apps_movies_books_links_or_ids',
  ADDRESSES: 'addresses',
  COMPANY_IDS_OR_URLS: 'company_ids_or_urls',
  COMPANY_NAMES_OR_URLS: 'company_names_or_urls',
  COMPANY_URLS: 'company_urls',
  CONTRIBUTOR_IDS_OR_URLS: 'contributor_ids_or_urls',
  COORDINATES_LATITUDE_LONGITUDE: 'coordinates_latitude_longitude',
  DOMAINS_OR_URLS: 'domains_or_urls',
  EMAIL_ADDRESSES: 'email_addresses',
  EVENT_IDS_OR_URLS: 'event_ids_or_urls',
  FB_PAGE_SEARCH_URLS: 'fb_page_search_urls',
  FULL_NAME_COMPANY_DOMAIN: 'full_name_company_domain',
  HASHTAGS_OR_HASHTAG_URLS: 'hashtags_or_hashtag_urls',
  JSON_FILTERS: 'json_filters',
  LINKS_TO_GOOGLE_CAREERS_SEARCHES: 'links_to_google_careers_searches',
  LINKS_TO_PAGES: 'links_to_pages',
  LINKS_TO_SHOPIFY_WEBSITES: 'links_to_shopify_websites',
  PHONE_NUMBERS_INTERNATIONAL: 'phone_numbers_international',
  PRODUCT_ASINS_OR_URLS: 'product_asins_or_urls',
  PRODUCT_OR_SEARCH_URLS: 'product_or_search_urls',
  QUERIES_BUSINESS_PROFILE_URLS: 'queries_business_profile_urls',
  QUERIES_CATEGORY_CITY_OR_ZIP_COUNTRY: 'queries_category_city_or_zip_country',
  QUERIES_STORE_URLS_OR_IDS: 'queries_store_urls_or_ids',
  QUERIES_TO_SEARCH: 'queries_to_search',
  RESTAURANT_IDS_OR_URLS: 'restaurant_ids_or_urls',
  SEARCH_OR_LISTING_URLS: 'search_or_listing_urls',
  SEARCH_QUERIES: 'search_queries',
  SEARCH_QUERIES_OR_URLS: 'search_queries_or_urls',
  SEARCH_URLS: 'search_urls',
  URLS: 'urls',
  URLS_TO_COMPANY_PROFILES_COMPANY_IDS: 'urls_to_company_profiles_company_ids',
  URLS_TO_DOORDASH_RESTAURANT_PAGES: 'urls_to_doordash_restaurant_pages',
  URLS_TO_FB_PAGES_PAGES_IDS: 'urls_to_fb_pages_pages_ids',
  URLS_TO_IG_PAGES_PROFILE_USERNAMES: 'urls_to_ig_pages_profile_usernames',
  URLS_TO_LINKEDIN_PEOPLE_SEARCH: 'urls_to_linkedin_people_search',
  URLS_TO_PROFILES_PROFILE_IDS: 'urls_to_profiles_profile_ids',
  US_PHONE_OR_ADDRESS_WITH_ZIP: 'us_phone_or_address_with_zip',
  US_PHONE_NUMBERS: 'us_phone_numbers',
  USERNAMES_OR_PAGES_URLS: 'usernames_or_pages_urls',
  VIDEO_IDS_OR_URLS: 'video_ids_or_urls',
  VIDEO_LINKS_OR_VIDEO_IDS: 'video_links_or_video_ids',
});

export const DOMAIN_QUERIES_LABEL = QUERY_LABEL_KEYS.DOMAINS_OR_URLS;
export const DOMAIN_QUERIES_PLACEHOLDER = 'company.com\nhttps://company2.com';
const CONTACTS_N_LEADS_OUTPUT_FIELDS = [
  'domain', 'company_name', 'company_phone', 'company_phones', 'company_linkedin', 'company_facebook', 'company_instagram', 'company_x', 'company_youtube',
  'full_name', 'first_name', 'last_name', 'title',
  'email', 'contact_phone', 'contact_phones',
  'contact_linkedin', 'contact_facebook', 'contact_instagram', 'contact_x',
  'website_title', 'website_description', 'website_generator',
  'website_has_fb_pixel', 'website_has_gtm',
  'source'
];
const COMPANIES_DATA_OUTPUT_FIELDS = [
  'company_name', 'legal_name', 'business_type', 'company_year_started', 'naics', 'naics_desc', 'sic6code', 'sic6desc', 'business_specialty',
  'state_where_entity_formed', 'ein', 'public', 'chain', 'franchise', 'home_office', 'parent_company',
  'telephone', 'telephone2', 'fax', 'toll_free_number', 'owner_phone', 'ethnicity',
  'url',
  'sales_volume', 'sales_code', 'company_sales', 'company_sales_code', 'number_of_employees', 'employee_code', 'company_num_emp',
];
const GOOGLE_MAPS_REVIEWS_OUTPUT_FIELDS = ['query', 'name', 'google_id', 'place_id', 'location_link', 'reviews_link', 'reviews_per_score', 'reviews', 'rating', 'review_id', 'review_pagination_id', 'author_link', 'author_title', 'author_id', 'author_image', 'review_text', 'review_img_url', 'review_img_urls', 'owner_answer', 'owner_answer_timestamp', 'owner_answer_timestamp_datetime_utc', 'review_link', 'review_rating', 'review_timestamp', 'review_datetime_utc', 'review_likes', 'reviews_id'];
const GOOGLE_PLACE_DOMAIN_SEARCH_OUTPUT_FIELDS = ['address', 'google_id', 'city', 'county', 'display_name', 'domain', 'name', 'owner_id', 'owner_title', 'phone', 'photo', 'photos_count', 'place_id', 'plus_code', 'postal_code', 'rating', 'reviews', 'reviews_id', 'reviews_link', 'site', 'state', 'street', 'time_zone', 'type', 'verified', 'business_status', 'updated_on', 'category', 'business_status_history', 'rating_history', 'reviews_history', 'country_code', 'os_id', 'types', 'area_service', 'description', 'location_link', 'longitude', 'latitude'];

const BIZ_DESCRIPTION = 'Returns data from a list of businesses';
const PROFILE_DESCRIPTION = 'Returns data from a list of profiles';

const REVIEWS_SUMMARY_OUTPUT_FIELDS = ['review_summary'];
const REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS = ['sentiment_score', 'positive_percent', 'negative_percent', 'neutral_percent', 'top_complaints', 'top_praises'];
export const REVIEWS_SUMMARY_SUBTITLE = 'Summarizes reviews and comments to uncover sentiment and key insights.';
export const REVIEWS_SENTIMENT_SUBTITLE = 'Analyzes reviews and comments into clear, actionable insights.';
//const PHONE_CHEKER_ESCRIPTION = 'Checks whether a phone is connected to the service';

const SEARCH_URLS_LABEL = QUERY_LABEL_KEYS.SEARCH_URLS;
const LISTING_OR_SEARCH_URLS_LABEL = QUERY_LABEL_KEYS.SEARCH_OR_LISTING_URLS;
const PRODUCT_OR_SEARCH_URLS_LABEL = QUERY_LABEL_KEYS.PRODUCT_OR_SEARCH_URLS;
const SEARCH_QUERIES_OR_URLS_LABEL = QUERY_LABEL_KEYS.SEARCH_QUERIES_OR_URLS;
const ADDRESSES_LABEL = QUERY_LABEL_KEYS.ADDRESSES;
const USERNAMES_OR_PAGES_URLS_LABEL = QUERY_LABEL_KEYS.USERNAMES_OR_PAGES_URLS;

const QUERY_LABEL_FALLBACKS = Object.freeze({
  [QUERY_LABEL_KEYS.APPS_MOVIES_BOOKS_LINKS_OR_IDS]: 'Apps, movies, books links or IDs',
  [QUERY_LABEL_KEYS.ADDRESSES]: 'Addresses',
  [QUERY_LABEL_KEYS.COMPANY_IDS_OR_URLS]: 'Company IDs or URLs',
  [QUERY_LABEL_KEYS.COMPANY_NAMES_OR_URLS]: 'Company names or URLs',
  [QUERY_LABEL_KEYS.COMPANY_URLS]: 'Company URLs',
  [QUERY_LABEL_KEYS.CONTRIBUTOR_IDS_OR_URLS]: 'Contributor IDs or URLs',
  [QUERY_LABEL_KEYS.COORDINATES_LATITUDE_LONGITUDE]: 'Coordinates (latitude + longitude)',
  [QUERY_LABEL_KEYS.DOMAINS_OR_URLS]: 'Domains or URLs',
  [QUERY_LABEL_KEYS.EMAIL_ADDRESSES]: 'Email addresses',
  [QUERY_LABEL_KEYS.EVENT_IDS_OR_URLS]: 'Event IDs or URLs',
  [QUERY_LABEL_KEYS.FB_PAGE_SEARCH_URLS]: 'FB page search URLs (Make sure you are using locations filters as servers IPs might have different locations)',
  [QUERY_LABEL_KEYS.FULL_NAME_COMPANY_DOMAIN]: 'Full name + company domain',
  [QUERY_LABEL_KEYS.HASHTAGS_OR_HASHTAG_URLS]: 'Hashtags or hashtag URLs',
  [QUERY_LABEL_KEYS.JSON_FILTERS]: 'JSON filters',
  [QUERY_LABEL_KEYS.LINKS_TO_GOOGLE_CAREERS_SEARCHES]: 'Links to Google Careers searches',
  [QUERY_LABEL_KEYS.LINKS_TO_PAGES]: 'Links to pages',
  [QUERY_LABEL_KEYS.LINKS_TO_SHOPIFY_WEBSITES]: 'Links to Shopify websites',
  [QUERY_LABEL_KEYS.PHONE_NUMBERS_INTERNATIONAL]: 'Phone numbers (international)',
  [QUERY_LABEL_KEYS.PRODUCT_ASINS_OR_URLS]: 'Product ASINs or URLs',
  [QUERY_LABEL_KEYS.PRODUCT_OR_SEARCH_URLS]: 'Product or Search URLs',
  [QUERY_LABEL_KEYS.QUERIES_BUSINESS_PROFILE_URLS]: 'Queries (Business Profile URLs)',
  [QUERY_LABEL_KEYS.QUERIES_CATEGORY_CITY_OR_ZIP_COUNTRY]: 'Queries (category + city or zip + country)',
  [QUERY_LABEL_KEYS.QUERIES_STORE_URLS_OR_IDS]: 'Queries (Store URLs or IDs)',
  [QUERY_LABEL_KEYS.QUERIES_TO_SEARCH]: 'Queries to search',
  [QUERY_LABEL_KEYS.RESTAURANT_IDS_OR_URLS]: 'Restaurant IDs or URLs',
  [QUERY_LABEL_KEYS.SEARCH_OR_LISTING_URLS]: 'Search or listing URLs',
  [QUERY_LABEL_KEYS.SEARCH_QUERIES]: 'Search Queries',
  [QUERY_LABEL_KEYS.SEARCH_QUERIES_OR_URLS]: 'Search Queries or URLs',
  [QUERY_LABEL_KEYS.SEARCH_URLS]: 'Search URLs',
  [QUERY_LABEL_KEYS.URLS]: 'URLs',
  [QUERY_LABEL_KEYS.URLS_TO_COMPANY_PROFILES_COMPANY_IDS]: 'URLs to company profiles, company IDs',
  [QUERY_LABEL_KEYS.URLS_TO_DOORDASH_RESTAURANT_PAGES]: 'URLs to DoorDash restaurant pages',
  [QUERY_LABEL_KEYS.URLS_TO_FB_PAGES_PAGES_IDS]: 'URLs to FB pages, pages IDs',
  [QUERY_LABEL_KEYS.URLS_TO_IG_PAGES_PROFILE_USERNAMES]: 'URLs to IG pages, profile usernames',
  [QUERY_LABEL_KEYS.URLS_TO_LINKEDIN_PEOPLE_SEARCH]: 'URLs to LinkedIn people search',
  [QUERY_LABEL_KEYS.URLS_TO_PROFILES_PROFILE_IDS]: 'URLs to profiles, profile IDs',
  [QUERY_LABEL_KEYS.US_PHONE_OR_ADDRESS_WITH_ZIP]: 'US phone number or US street address with ZIP code',
  [QUERY_LABEL_KEYS.US_PHONE_NUMBERS]: 'US phone numbers',
  [QUERY_LABEL_KEYS.USERNAMES_OR_PAGES_URLS]: 'Usernames or pages URLs',
  [QUERY_LABEL_KEYS.VIDEO_IDS_OR_URLS]: 'Video IDs or URLs',
  [QUERY_LABEL_KEYS.VIDEO_LINKS_OR_VIDEO_IDS]: 'Video links or video IDs',
});

export const getServiceQueriesLabelFallback = (queriesLabelKey, fallbackLabel = queriesLabelKey) => (
  QUERY_LABEL_FALLBACKS[queriesLabelKey] || fallbackLabel
);

const homeUrl = config.get('homeUrl');

const allServiceGroups = {
  email: 'description.bestForEmail',
  phone: 'description.bestForPhone',
  analytics: 'description.bestForAnalytics',
  other: 'description.bestForOther',
};

export const newServices = {
  'tiktok_comments': 1755712615,
  'google_search_flights': 1756138772,
  'google_maps_autocomplete': 1756113659,
  'uber_eats': 1757757737,
  'deliveroo': 1757757737,
  'deliveroo_reviews': 1757757737,
  'zoominfo': 1757757737,
  'zoominfo_domains': 1757757737,
  'crunchbase': 1758245750,
  'crunchbase_search': 1758245750,
  'domaininfo': 1758245750,
  'olx': 1758307510,
  'apollo': 1758245549,
  'feedbackcompany': 1758245750,
  'feedbackcompany_reviews': 1758245750,
  'willhaben': 1760453543,
  'mobilede': 1760453543,
  'immowelt': 1760453543,
  'allegro': 1760453543,
  'craigslist': 1760453543,
  '1688_search': 1760453543,
  'glassdoor_company_jobs': 1760453543,
  'upwork_jobs': 1761623256,
  'offerup': 1762146000,
  'angi': 1762146000,
  'feefo_reviews': 1762146000,
  'thuisbezorgd_reviews': 1762146000,
  'producthunt_profiles': 1762146000,
  'people_search': 1789344000,
  'ads_checker': 1789430400,
};

export const defaultWebsiteEnrichments = ['domains_service', 'emails_validator_service', 'company_insights_service'];
export const defaultPhoneEnrichments = ['whitepages_phones'];

export function checkIfNewService(key, recentNewServicesArray) {
  if (key in newServices && !recentNewServicesArray.includes(key)) {
    return ((Date.now() / 1000 - newServices[key]) < 4 * 7 * 24 * 60 * 60);
  } else {
    return false;
  }
}

export const SERVICES_DATA = {
  //Enrichments
  domains_service: {
    label: 'Emails & Contacts Scraper',
    key: 'emails-scraper',
    description: 'Finds emails, social links, phones, and other contacts from websites',
    unit: 'domain',
    input_fields: DOMAIN_INPUT_FIELDS,
    output_fields: DOMAINS_SERVICE_OUTPUT_FIELDS,
    output_ontologies: ['email', 'phone'],
    groups: ['email'],
    incompatible_with: ['leads_n_contacts', 'contacts_n_leads'],
    isRecommended: false,
    hasFilters: true,
    hasParameters: true,
    icon: serviceIcons.EmailsContactsScraper,
    recommendedServices: ['emails_validator_service'],
    excludedEnrichmentServices: ['contacts_finder_service', 'leads_n_contacts', 'contacts_n_leads'],
    supportedEnrichmentServices: [],
    queriesLabel: DOMAIN_QUERIES_LABEL,
    queriesPlaceholder: DOMAIN_QUERIES_PLACEHOLDER,
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['contactLeads'],
    popularityRank: 3
  },
  leads_n_contacts: {
    label: 'Leads & Contacts Enrichment',
    key: 'contacts-n-leads',
    description: 'Finds emails, social links, phones, and other contacts from websites',
    unit: 'contact',
    input_fields: DOMAIN_INPUT_FIELDS,
    output_fields: CONTACTS_N_LEADS_OUTPUT_FIELDS,
    output_ontologies: ['email', 'phone'],
    groups: ['email'],
    incompatible_with: ['domains_service'],
    isRecommended: true,
    hasFilters: true,
    hasParameters: true,
    icon: serviceIcons.ContactsFinder,
    recommendedServices: ['emails_validator_service'],
    supportedEnrichmentServices: [],
    excludedEnrichmentServices: ['domains_service'],
    queriesLabel: DOMAIN_QUERIES_LABEL,
    queriesPlaceholder: DOMAIN_QUERIES_PLACEHOLDER,
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['contactLeads'],
  },
  emails_validator_service: {
    label: 'Email Address Verifier',
    key: 'emails-validator',
    description: 'Validates email addresses and checks deliverability.',
    unit: 'email',
    input_fields: EMAIL_INPUT_FIELDS,
    output_fields: ['status', 'status_details'],
    groups: ['email'],
    isRecommended: true,
    icon: serviceIcons.EmailAddressVerifier,
    supportedEnrichmentServices: [],
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['contactLeads'],
    popularityRank: 4
  },
  company_insights_service: {
    label: 'Company Insights',
    key: 'company-insights',
    description: 'Finds company information such as revenue, company size, founding year, and whether the company is publicly traded.',
    unit: 'company',
    input_fields: DOMAIN_INPUT_FIELDS,
    output_fields: ['employees', 'revenue', 'founded_year', 'industry', 'is_public', 'name', 'country', 'state', 'city', 'zip', 'address'],
    groups: ['email'],
    isRecommended: true,
    icon: serviceIcons.CompanyInsights,
    recommendedServices: ['ai_chain_info', 'similarweb'],
    supportedEnrichmentServices: [],
    queriesLabel: DOMAIN_QUERIES_LABEL,
    queriesPlaceholder: DOMAIN_QUERIES_PLACEHOLDER,
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['pois', 'contactLeads'],
    popularityRank: 5
  },
  phones_enricher_service: {
    label: 'Phone Numbers Enricher',
    key: 'phones-enricher',
    description: 'Returns phones carrier data (name/type), validates phones, ensures messages deliverability',
    unit: 'phone',
    input_fields: PHONE_INPUT_FIELDS,
    output_fields: ['carrier_name', 'carrier_type'],
    groups: ['phone'],
    icon: serviceIcons.PhoneNumbersEnricher,
    recommendedServices: ['whitepages_phones'],
    supportedEnrichmentServices: [],
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['contactLeads'],
    popularityRank: 10
  },
  whitepages_phones: {
    label: 'Phone Identity Finder',
    key: 'whitepages-phones',
    description: 'Returns insights about phone number owners (name, address, etc.)',
    unit: 'phone',
    input_fields: PHONE_INPUT_FIELDS,
    output_fields: ['name', 'phone_type', 'address'],
    supported_regions: ['US', 'CA'],
    groups: ['phone'],
    isRecommended: true,
    icon: serviceIcons.PhoneIdentityFinder,
    supportedEnrichmentServices: [],
    isEnrichment: true,
    brand: 'Whitepages',
    categories: ['contactLeads']
  },
  people_search: {
    label: 'People Search',
    key: 'people-search',
    queriesLabel: QUERY_LABEL_KEYS.US_PHONE_OR_ADDRESS_WITH_ZIP,
    queriesPlaceholder: '1 281 236 8208\n1600 Pennsylvania Ave NW, Washington, DC 20500',
    description: 'Finds people candidates from a US phone number or US street address containing a ZIP code',
    unit: 'candidate',
    input_fields: [...PHONE_INPUT_FIELDS, 'phone number', 'full_address'],
    output_fields: ['candidates_count', 'candidate_1_name', 'candidate_1_age', 'candidate_1_other_phones', 'candidate_1_address', 'candidate_1_past_addresses'],
    output_ontologies: ['phone', 'address'],
    supported_regions: ['US'],
    groups: ['phone', 'other'],
    icon: serviceIcons.PhoneIdentityFinder,
    supportedEnrichmentServices: [],
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['contactLeads'],
  },
  similarweb: {
    label: 'SimilarWeb Scraper',
    key: 'similarweb',
    description: 'Provides web data for domains including traffic statistics, engagement metrics, and audience insights',
    unit: 'domain',
    input_fields: DOMAIN_INPUT_FIELDS,
    output_fields: ['traffic', 'engagement', 'audience', 'geography', 'competitors', 'keywords', 'referrals', 'social_traffic'],
    groups: ['other'],
    isRecommended: true,
    icon: serviceIcons.SimilarWebScraper,
    supportedEnrichmentServices: [],
    queriesLabel: DOMAIN_QUERIES_LABEL,
    queriesPlaceholder: DOMAIN_QUERIES_PLACEHOLDER,
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['pois', 'domainWeb']
  },
  ads_checker: {
    label: 'Ads Checker',
    key: 'ads-checker',
    description: 'Instantly find out if a business is running paid ads - just enter a domain. Detects advertising signals in Google Ads Transparency and LinkedIn Ad Library.',
    unit: 'domain',
    input_fields: DOMAIN_INPUT_FIELDS,
    output_fields: ['ads', 'google', 'linkedin'],
    groups: ['other'],
    isRecommended: true,
    icon: serviceIcons.AdsChecker,
    supportedEnrichmentServices: [],
    queriesLabel: DOMAIN_QUERIES_LABEL,
    queriesPlaceholder: DOMAIN_QUERIES_PLACEHOLDER,
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['pois', 'domainWeb']
  },
  ai_chain_info: {
    label: 'Chain Info',
    key: 'ai-chain-info',
    description: 'Identifies if a business is part of a chain, adding a true/false indication to your data for smarter targeting',
    unit: 'company',
    output_fields: ['chain'],
    groups: ['other'],
    supported_services: ['google_maps_service'],
    hasPage: false,
    icon: serviceIcons.ChainInfo,
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['pois', 'domainWeb'],
    popularityRank: 7
  },
  airbnb_reviews_sentiment: {
    label: 'Airbnb Reviews Sentiment Analysis',
    key: 'airbnb-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['airbnb_listing_url'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.AirbnbReviewsSentimentAnalysis,
    isEnrichment: true
  },
  airbnb_reviews_summary: {
    label: 'Airbnb Reviews Summary',
    key: 'airbnb-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['airbnb_listing_url'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.AirbnbReviewsSummary,
    isEnrichment: true
  },
  builtwith: {
    label: 'BuiltWith Scraper',
    key: 'builtwith',
    description: 'Returns detailed information about a website’s tech stack',
    unit: 'domain',
    input_fields: DOMAIN_INPUT_FIELDS,
    output_fields: [],
    groups: ['other'],
    queriesLabel: DOMAIN_QUERIES_LABEL,
    queriesPlaceholder: DOMAIN_QUERIES_PLACEHOLDER,
    icon: serviceIcons.BuiltWithScraper,
    supportedEnrichmentServices: [],
    isEnrichment: true,
    brand: 'Builtwith',
    categories: ['domainWeb'],
    popularityRank: 19
  },
  booking_reviews_sentiment: {
    label: 'Booking Reviews Sentiment Analysis',
    key: 'booking-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['booking_listing_url'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.BookingReviewsSentimentAnalysis,
    isEnrichment: true
  },
  booking_reviews_summary: {
    label: 'Booking Reviews Summary',
    key: 'booking-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['booking_listing_url'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.BookingReviewsSummary,
    isEnrichment: true
  },
  bestbuy_reviews_sentiment: {
    label: 'BestBuy Reviews Sentiment Analysis',
    key: 'bestbuy-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['bestbuy_product_url'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.BestBuyReviewsSentimentAnalysis,
    isEnrichment: true
  },
  bestbuy_reviews_summary: {
    label: 'BestBuy Reviews Summary',
    key: 'bestbuy-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['bestbuy_product_url'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'], isRecommended: true,
    hasPage: false,
    icon: serviceIcons.BestBuyReviewsSummary,
    isEnrichment: true
  },
  expedia_reviews_sentiment: {
    label: 'Expedia Reviews Sentiment Analysis',
    key: 'expedia-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['expedia_listing_url'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.ExpediaReviewsSentimentAnalysis,
    isEnrichment: true
  },
  expedia_reviews_summary: {
    label: 'Expedia Reviews Summary',
    key: 'expedia-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['expedia_listing_url'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.ExpediaReviewsSummary,
    isEnrichment: true
  },
  fastbackgroundcheck_addresses: {
    label: 'Fastbackgroundcheck Addresses Scraper',
    key: 'fastbackgroundcheck-addresses',
    queriesLabel: ADDRESSES_LABEL,
    description: 'Returns insights about addresses and their residents',
    unit: 'address',
    input_fields: ['full_address', 'address'],
    output_fields: [],
    supported_regions: ['US'],
    groups: ['other'],
    icon: serviceIcons.FastbackgroundcheckAddressesScraper,
    supportedEnrichmentServices: [],
    isEnrichment: true,
    brand: 'FastBackgroundCheck',
    categories: ['pois'],
  },
  google_maps_reviews_sentiment: {
    label: 'Google Maps Reviews Sentiment Analysis',
    key: 'google-maps-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['google_id', 'place_id'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    hasPage: false,
    icon: serviceIcons.GoogleMapsReviewsSentimentAnalysis,
    isEnrichment: true
  },
  google_maps_reviews_summary: {
    label: 'Google Maps Reviews Summary',
    key: 'google-maps-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['google_id', 'place_id'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    hasPage: false,
    icon: serviceIcons.GoogleMapsReviewsSummary,
    isEnrichment: true
  },
  glassdoor_reviews_sentiment: {
    label: 'Glassdoor Reviews Sentiment Analysis',
    key: 'glassdoor-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['glassdoor_company_url'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.GlassdoorReviewsSentimentAnalysis,
    isEnrichment: true
  },
  glassdoor_reviews_summary: {
    label: 'Glassdoor Reviews Summary',
    key: 'glassdoor-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['glassdoor_company_url'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.GlassdoorReviewsSummary,
    isEnrichment: true
  },
  homedepot_reviews_sentiment: {
    label: 'Home Depot Reviews Sentiment Analysis',
    key: 'homedepot-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['homedepot_product_url'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.HomeDepotReviewsSentimentAnalysis,
    isEnrichment: true
  },
  homedepot_reviews_summary: {
    label: 'Home Depot Reviews Summary',
    key: 'homedepot-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['homedepot_product_url'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.HomeDepotReviewsSummary,
    isEnrichment: true
  },
  hotels_reviews_sentiment: {
    label: 'Hotels Reviews Sentiment Analysis',
    key: 'hotels-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['hotels_listing_url'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.HotelsReviewsSentimentAnalysis,
    isEnrichment: true
  },
  hotels_reviews_summary: {
    label: 'Hotels Reviews Summary',
    key: 'hotels-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['hotels_listing_url'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.HotelsReviewsSummary,
    isEnrichment: true
  },
  etsy_reviews_sentiment: {
    label: 'Etsy Reviews Sentiment Analysis',
    key: 'etsy-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['etsy_product_url'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.EtsyReviewsSentimentAnalysis,
    isEnrichment: true
  },
  etsy_reviews_summary: {
    label: 'Etsy Reviews Summary',
    key: 'etsy-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['etsy_product_url'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.EtsyReviewsSummary,
    isEnrichment: true
  },
  indeed_reviews_sentiment: {
    label: 'Indeed Reviews Sentiment Analysis',
    key: 'indeed-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['indeedCompanyUrl'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.IndeedReviewsSentimentAnalysis,
    isEnrichment: true
  },
  indeed_reviews_summary: {
    label: 'Indeed Reviews Summary',
    key: 'indeed-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['indeedCompanyUrl'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.IndeedReviewsSummary,
    isEnrichment: true
  },
  linkedin_companies_service: {
    label: 'LinkedIn Companies Scraper',
    key: 'linkedin-companies',
    description: BIZ_DESCRIPTION,
    unit: 'company',
    input_fields: ['linkedin', 'linkedin_company', 'linkedin_company_page', 'linkedin_company_url'],
    output_fields: ['name', 'headline', 'subline', 'about', 'website', 'industries', 'size', 'employees_on_linkedin', 'headquarters', 'type', 'founded', 'specialties', 'url'],
    output_ontologies: ['email', 'domain'],
    groups: ['other'],
    icon: serviceIcons.LinkedinCompaniesScraper,
    supportedEnrichmentServices: [],
    isEnrichment: true,
    brand: 'LinkedIn',
    categories: ['pois'],
  },
  linkedin_profiles: {
    label: 'LinkedIn Profiles Scraper',
    key: 'linkedin-profiles',
    description: PROFILE_DESCRIPTION,
    unit: 'profile',
    input_fields: ['linkedin', 'linkedin_profile', 'linkedin_profile_page', 'linkedin_profile_url'],
    output_fields: [],
    output_ontologies: [],
    groups: ['other'],
    icon: serviceIcons.LinkedinProfilesScraper,
    supportedEnrichmentServices: [],
    isEnrichment: true,
    brand: 'LinkedIn',
    categories: ['socialSearch'],
  },
  linkedin_posts: {
    label: 'LinkedIn Posts Scraper',
    key: 'linkedin-posts',
    description: 'Returns posts from a list of profiles',
    unit: 'post',
    input_fields: ['linkedin', 'linkedin_company', 'linkedin_company_page', 'linkedin_company_url'],
    output_fields: [],
    output_ontologies: [],
    groups: ['other'],
    icon: serviceIcons.LinkedinPostsScraper,
    isEnrichment: true,
    brand: 'LinkedIn',
    categories: ['socialSearch'],
  },
  target_reviews_sentiment: {
    label: 'Target Reviews Sentiment Analysis',
    key: 'target-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['target_product_url'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.TargetReviewsSentimentAnalysis,
    isEnrichment: true
  },
  target_reviews_summary: {
    label: 'Target Reviews Summary',
    key: 'target-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['target_product_url'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.TargetReviewsSummary,
    isEnrichment: true
  },
  tripadvisor_reviews_sentiment: {
    label: 'Tripadvisor Reviews Sentiment Analysis',
    key: 'tripadvisor-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['tripadvisor_listing_url'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.TripadvisorReviewsSentimentAnalysis,
    isEnrichment: true
  },
  tripadvisor_reviews_summary: {
    label: 'Tripadvisor Reviews Summary',
    key: 'tripadvisor-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['tripadvisor_listing_url'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.TripadvisorReviewsSummary,
    isEnrichment: true
  },
  trustpilot_service: {
    label: 'Trustpilot Scraper',
    key: 'trustpilot',
    description: BIZ_DESCRIPTION,
    unit: 'domain',
    input_fields: DOMAIN_INPUT_FIELDS,
    output_fields: ['name', 'rating', 'reviews', 'site', 'profile_image', 'page_url', 'claimed', 'closed', 'temporarily_closed', 'categories', 'email', 'phone', 'address', 'city', 'country', 'zip_code'],
    output_ontologies: ['email', 'phone'],
    groups: ['other'],
    icon: serviceIcons.TrustpilotScraper,
    supportedEnrichmentServices: [],
    isEnrichment: true,
    brand: 'Trustpilot',
    categories: ['pois'],
    popularityRank: 14
  },
  trustpilot_search_service: {
    label: 'Trustpilot Search Scraper',
    key: 'trustpilot-search',
    description: 'Returns search results',
    unit: 'company',
    output_fields: ['name', 'rating', 'reviews', 'site', 'profile_image', 'page_url', 'claimed', 'closed', 'temporarily_closed', 'categories', 'email', 'phone', 'address', 'city', 'country', 'zip_code'],
    output_ontologies: ['email', 'domain', 'phone'],
    groups: ['other'],
    icon: serviceIcons.TrustpilotSearchScraper,
    excludedEnrichmentServices: ['trustpilot_service'],
    supportedEnrichmentServices: [],
    isEnrichment: true,
    brand: 'Trustpilot',
    categories: ['pois'],
  },
  trustpilot_reviews_sentiment: {
    label: 'Trustpilot Reviews Sentiment Analysis',
    key: 'trustpilot-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: DOMAIN_INPUT_FIELDS,
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    hasPage: false,
    icon: serviceIcons.TrustpilotReviewsSentimentAnalysis,
    isEnrichment: true,
    brand: 'Trustpilot',
    categories: ['reviews'],
  },
  trustpilot_reviews_summary: {
    label: 'Trustpilot Reviews Summary',
    key: 'trustpilot-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: DOMAIN_INPUT_FIELDS,
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    hasPage: false,
    icon: serviceIcons.TrustpilotReviewsSummary,
    isEnrichment: true,
    brand: 'Trustpilot',
    categories: ['reviews'],
  },
  walmart_reviews_sentiment: {
    label: 'Walmart Reviews Sentiment Analysis',
    key: 'walmart-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['walmart_product_url'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.WalmartReviewsSentimentAnalysis,
    isEnrichment: true
  },
  walmart_reviews_summary: {
    label: 'Walmart Reviews Summary',
    key: 'walmart-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['walmart_product_url'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.WalmartReviewsSummary,
    isEnrichment: true
  },
  whitepages_addresses: {
    label: 'Whitepages Addresses Scraper',
    key: 'whitepages-addresses',
    queriesLabel: ADDRESSES_LABEL,
    description: 'Returns insights about addresses and their residents',
    unit: 'address',
    input_fields: ['full_address', 'address'],
    output_fields: ['building_type', 'full_address', 'residents_count', 'resident_1_first_name', 'resident_1_last_name', 'resident_1_age_range', 'resident_1_phones', 'resident_2_first_name', 'resident_2_last_name', 'resident_2_age_range', 'resident_2_phones', 'resident_3_first_name', 'resident_3_last_name', 'resident_3_age_range', 'resident_3_phones'],
    supported_regions: ['US'],
    groups: ['other'],
    icon: serviceIcons.WhitepagesAddressesScraper,
    supportedEnrichmentServices: [],
    isEnrichment: true,
    brand: 'Whitepages',
    categories: ['pois'],
  },
  youtube_channel_service: {
    label: 'YouTube Channels Scraper',
    key: 'youtube-channels',
    description: PROFILE_DESCRIPTION,
    unit: 'profile',
    input_fields: ['channel_url', 'youtube_channel'],
    output_fields: [],
    output_ontologies: [],
    groups: ['other'],
    icon: serviceIcons.YouTubeChannelsScraper,
    isEnrichment: true,
    brand: 'YouTube',
    categories: ['socialSearch'],
  },
  youtube_comments_sentiment: {
    label: 'YouTube Comments Sentiment Analysis',
    key: 'youtube-comments-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['youtube_video_url', 'youtube_video_id'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.YouTubeCommentsSentimentAnalysis,
    isEnrichment: true
  },
  youtube_comments_summary: {
    label: 'YouTube Comments Summary',
    key: 'youtube-comments-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['youtube_video_url', 'youtube_video_id'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.YouTubeCommentsSummary,
    isEnrichment: true
  },
  yelp_reviews_sentiment: {
    label: 'Y.E.L.P Reviews Sentiment Analysis',
    key: 'yelp-reviews-sentiment',
    description: REVIEWS_SENTIMENT_SUBTITLE,
    unit: 'report',
    input_fields: ['yelp_business_url', 'yelp_biz_id'],
    output_fields: REVIEWS_SENTIMENT_ANALYSIS_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.YelpReviewsSentimentAnalysis,
    isEnrichment: true
  },
  yelp_reviews_summary: {
    label: 'Y.E.L.P Reviews Summary',
    key: 'yelp-reviews-summary',
    description: REVIEWS_SUMMARY_SUBTITLE,
    unit: 'report',
    input_fields: ['yelp_business_url', 'yelp_biz_id'],
    output_fields: REVIEWS_SUMMARY_OUTPUT_FIELDS,
    groups: ['analytics'],
    isRecommended: true,
    hasPage: false,
    icon: serviceIcons.YelpReviewsSummary,
    isEnrichment: true
  },
  disposable_email_checker: {
    label: 'Disposable Email Checker',
    key: 'disposable-email-checker',
    description: 'Checks origins of email addresses (disposable, free, or corporate)',
    unit: 'email',
    input_fields: EMAIL_INPUT_FIELDS,
    output_fields: ['is_disposable', 'is_free_email'],
    groups: ['email'],
    icon: serviceIcons.DisposableEmailChecker,
    supportedEnrichmentServices: [],
    isEnrichment: true,
    categories: ['contactLeads']
  },
  geocoding: {
    label: 'Geocoding',
    key: 'geocoding',
    queriesLabel: ADDRESSES_LABEL,
    description: 'Translates human-readable addresses into locations on the map (latitude, longitude)',
    unit: 'search',
    input_fields: ['address', ['state', 'city', 'county', 'street', 'postal_code']],
    output_fields: ['latitude', 'longitude', 'country', 'state', 'city', 'borough', 'street', 'postal_code', 'time_zone', 'street_view'],
    output_ontologies: [],
    groups: ['other'],
    icon: serviceIcons.Geocoding,
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['domainWeb']
  },
  reverse_geocoding: {
    label: 'Reverse Geocoding',
    key: 'reverse-geocoding',
    description: 'Translates locations on the map into human-readable addresses',
    unit: 'search',
    input_fields: ['coordinates', ['latitude', 'longitude'], ['lat', 'long']],
    output_fields: ['country_code', 'state', 'city', 'county', 'street', 'address', 'postal_code', 'plus_code', 'photo', 'time_zone'],
    output_ontologies: ['address'],
    groups: ['other'],
    icon: serviceIcons.ReverseGeocoding,
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['domainWeb']
  },
  screenshoter: {
    label: 'WebPage Screenshoter',
    key: 'screenshoter',
    description: 'Captures high-quality screenshots of any webpage simply by providing its URL',
    unit: 'page',
    input_fields: [],
    output_fields: ['screenshot'],
    groups: ['other'],
    icon: serviceIcons.WebPageScreenshoter,
    isEnrichment: true,
    brand: 'Multi-source',
    categories: ['domainWeb']
  },
  company_websites_finder: {
    label: 'Company Website Finder',
    key: 'company-website-finder',
    description: 'Finds company websites based on business names',
    unit: 'domain',
    input_fields: COMPANY_NAME_INPUT_FIELDS,
    output_fields: ['website'],
    groups: ['other'],
    isRecommended: false,
    hasPage: false,
    icon: serviceIcons.CompanyWebsiteFinder,
    isEnrichment: true
  },
  companies_data: {
    label: 'US Companies Data Enricher',
    key: 'companies-data',
    description: 'Enriches places with legal names, phones, NAICS, SIC, employees number, sales volume, etc',
    unit: 'company',
    output_fields: COMPANIES_DATA_OUTPUT_FIELDS,
    supported_regions: ['US'],
    supported_services: ['google_maps_service'],
    groups: ['other'],
    hasPage: false,
    icon: serviceIcons.USCompaniesDataEnricher,
    isEnrichment: true
  },
  zoominfo_domains: {
    label: 'Zoominfo by Domains',
    key: 'zoominfo-domains',
    unit: 'domain',
    input_fields: DOMAIN_INPUT_FIELDS,
    icon: serviceIcons.ZoominfoByDomains,
    queriesLabel: DOMAIN_QUERIES_LABEL,
    queriesPlaceholder: DOMAIN_QUERIES_PLACEHOLDER,
    isEnrichment: true,
    brand: 'ZoomInfo',
    categories: ['domainWeb']
  },
  domaininfo: {
    label: 'Domain Information',
    key: 'domaininfo',
    description: 'Enriches domains with WHOIS data, including registrar, registration dates, expiration date, nameservers, and ownership details when available.',
    unit: 'domain',
    input_fields: DOMAIN_INPUT_FIELDS,
    icon: serviceIcons.DomainInformation,
    queriesLabel: DOMAIN_QUERIES_LABEL,
    queriesPlaceholder: DOMAIN_QUERIES_PLACEHOLDER,
    isEnrichment: true,
    brand: 'DomainInfo',
    categories: ['domainWeb']
  },

  // Not Enrichments
  google_search_flights: {
    label: 'Google Search Flights Scraper',
    key: 'google-search-flights',
    description: 'Returns flight search results from Google Flights',
    unit: 'flight',
    input_fields: [],
    output_fields: [],
    groups: ['other'],
    hasParameters: true,
    icon: serviceIcons.GoogleSearchFlightsScraper,
    brand: 'Google',
    categories: ['socialSearch']
  },
  google_maps_autocomplete: {
    label: 'Google Maps Autocomplete',
    key: 'google-maps-autocomplete',
    description: 'Returns autocomplete suggestions for Google Maps search queries',
    unit: 'search',
    icon: serviceIcons.GoogleMapsAutocomplete,
    brand: 'Google',
    categories: ['socialSearch']
  },
  google_search_autocomplete: {
    label: 'Google Search Autocomplete',
    key: 'google-search-autocomplete',
    description: 'Returns autocomplete suggestions from Google Search',
    unit: 'suggestion',
    icon: serviceIcons.GoogleSearchAutocomplete,
    brand: 'Google',
    categories: ['socialSearch']
  },
  yahoo_search: {
    label: 'Yahoo Search Scraper',
    key: 'yahoo-search',
    queriesLabel: SEARCH_QUERIES_OR_URLS_LABEL,
    description: 'Returns search results',
    unit: 'result',
    supportedEnrichmentServices: [],
    output_fields: [],
    icon: serviceIcons.YahooSearchScraper,
    brand: 'Yahoo',
    categories: ['socialSearch']
  },
  eventbrite: {
    label: 'Eventbrite Scraper',
    key: 'eventbrite',
    description: 'Returns event listings from Eventbrite',
    unit: 'listing',
    input_fields: ['eventbrite_url', 'event_id', 'search_url'],
    output_fields: ['address', 'price', 'bedrooms', 'bathrooms', 'sqft', 'listing_type', 'description', 'amenities', 'contact_info'],
    groups: ['other'],
    icon: serviceIcons.EventbriteListingsScraper,
    supportedEnrichmentServices: [],
    brand: 'Eventbrite',
    categories: ['socialSearch']
  },
  meetup: {
    label: 'Meetup Scraper',
    key: 'meetup',
    queriesLabel: SEARCH_QUERIES_OR_URLS_LABEL,
    description: 'Returns event listings from Meetup.com',
    unit: 'listing',
    input_fields: [],
    output_fields: [],
    groups: ['other'],
    icon: serviceIcons.MeetupListingsScraper,
    brand: 'Meetup',
    categories: ['socialSearch']
  },
  glassdoor_company_search: {
    label: 'Glassdoor Company Search',
    key: 'glassdoor-company-search',
    queriesLabel: SEARCH_QUERIES_OR_URLS_LABEL,
    description: 'Returns company search results from Glassdoor',
    unit: 'company',
    icon: serviceIcons.GlassdoorCompanySearch,
    supportedEnrichmentServices: [],
    output_fields: ['company_name', 'company_url', 'rating', 'reviews_count', 'size', 'industry', 'headquarters'],
    brand: 'Glassdoor',
    categories: ['socialSearch']
  },
  tiktok_hashtags: {
    label: 'TikTok Hashtags Scraper',
    key: 'tiktok-hashtags',
    description: 'Returns data from TikTok hashtag pages',
    unit: 'post',
    input_fields: ['hashtag', 'hashtag_url'],
    output_fields: ['video_id', 'video_url', 'author', 'description', 'likes', 'shares', 'comments', 'views', 'hashtags', 'music', 'duration'],
    groups: ['other'],
    icon: serviceIcons.TikTokHashtagsScraper,
    brand: 'TikTok',
    categories: ['socialSearch']
  },
  tiktok_search: {
    label: 'TikTok Search Scraper',
    key: 'tiktok-search',
    description: 'Returns search results from TikTok',
    unit: 'result',
    input_fields: ['search_query'],
    output_fields: ['video_id', 'video_url', 'author', 'description', 'likes', 'shares', 'comments', 'views', 'hashtags', 'music', 'duration', 'profile_url'],
    groups: ['other'],
    hasParameters: true,
    icon: serviceIcons.TikTokSearchScraper,
    brand: 'TikTok',
    categories: ['socialSearch']
  },
  tiktok_videos: {
    label: 'TikTok Videos Scraper',
    key: 'tiktok-videos',
    description: 'Returns data from TikTok video URLs',
    unit: 'video',
    input_fields: ['video_url', 'video_id'],
    output_fields: ['video_id', 'video_url', 'author', 'description', 'likes', 'shares', 'comments', 'views', 'hashtags', 'music', 'duration', 'profile_url', 'upload_date'],
    groups: ['other'],
    icon: serviceIcons.TikTokVideosScraper,
    brand: 'TikTok',
    categories: ['socialSearch']
  },
  tiktok_comments: {
    label: 'TikTok Comments Scraper',
    key: 'tiktok-comments',
    description: 'Returns comments from TikTok videos',
    unit: 'comment',
    icon: serviceIcons.TikTokCommentsScraper,
    input_fields: ['video_url', 'video_id'],
    brand: 'TikTok',
    categories: ['socialSearch']
  },
  amazon_products_service: {
    label: 'Amazon Products Scraper',
    key: 'amazon-products',
    version: 2,
    unit: 'product',
    icon: serviceIcons.AmazonProductsScraper,
    brand: 'Amazon',
    categories: ['products']
  },
  amazon_reviews_service: {
    label: 'Amazon Reviews Scraper',
    key: 'amazon-reviews',
    version: 2,
    description: 'Returns reviews from a list of products',
    unit: 'review',
    icon: serviceIcons.AmazonReviewsScraper,
    brand: 'Amazon',
    categories: ['reviews']
  },
  asos_products: {
    label: 'Asos Products Scraper',
    key: 'asos-products',
    unit: 'product',
    icon: serviceIcons.AsosProductsScraper,
    brand: 'Asos',
    categories: ['products']
  },
  appstore_reviews_service: {
    label: 'AppStore Reviews Scraper',
    key: 'appstore-reviews',
    description: 'Returns reviews from a list of apps/podcasts',
    unit: 'review',
    icon: serviceIcons.AppStoreReviewsScraper,
    brand: 'Apple',
    categories: ['reviews']
  },
  airbnb_search: {
    label: 'Airbnb Search Scraper',
    key: 'airbnb-search',
    queriesLabel: SEARCH_URLS_LABEL,
    description: 'Returns search results',
    unit: 'record',
    icon: serviceIcons.AirbnbSearchScraper,
    supportedEnrichmentServices: [],
    output_fields: ['listing_url'],
    brand: 'Airbnb',
    categories: ['pois']
  },
  appstore_search_service: {
    label: 'AppStore Search Scraper',
    key: 'appstore-search-scraper',
    queriesLabel: SEARCH_URLS_LABEL,
    description: 'Returns search results',
    unit: 'search',
    icon: serviceIcons.AppStoreSearchScraper,
    brand: 'Apple',
    categories: ['socialSearch']
  },
  airbnb_reviews: {
    label: 'Airbnb Reviews Scraper',
    key: 'airbnb-reviews',
    description: 'Returns reviews from accommodations',
    unit: 'review',
    input_fields: ['listing_url'],
    icon: serviceIcons.AirbnbReviewsScraper,
    brand: 'Airbnb',
    categories: ['reviews']
  },
  biggestbook_products: {
    label: 'BiggestBook Products Scraper',
    key: 'biggestbook-products',
    unit: 'product',
    icon: serviceIcons.BiggestBookProductsScraper,
    brand: 'BiggestBook',
    categories: ['products']
  },
  vistaprint_products: {
    label: 'Vistaprint Products Scraper',
    key: 'vistaprint-products',
    unit: 'product',
    icon: serviceIcons.VistaprintProductsScraper,
    brand: 'Vistaprint',
    categories: ['products']
  },
  waxie_products: {
    label: 'Waxie Products Scraper',
    key: 'waxie-products',
    unit: 'product',
    icon: serviceIcons.WaxieProductsScraper,
    brand: 'Waxie',
    categories: ['products']
  },
  otto_products: {
    label: 'Otto Products Scraper',
    key: 'otto-products',
    unit: 'product',
    icon: serviceIcons.OttoProductsScraper,
    brand: 'Otto',
    categories: ['products']
  },
  homedepot_products: {
    label: 'Home Depot Products Scraper',
    key: 'homedepot-products',
    unit: 'product',
    icon: serviceIcons.HomeDepotProductsScraper,
    brand: 'Home Depot',
    categories: ['products']
  },
  newegg_products: {
    label: 'Newegg Products Scraper',
    key: 'newegg-products',
    unit: 'product',
    icon: serviceIcons.NeweggProductsScraper,
    brand: 'Newegg',
    categories: ['products']
  },
  cdw_products: {
    label: 'CDW Products Scraper',
    key: 'cdw-products',
    unit: 'product',
    icon: serviceIcons.CDWProductsScraper,
    brand: 'CDW',
    categories: ['products']
  },
  bestbuy_products: {
    label: 'BestBuy Products Scraper',
    key: 'bestbuy-products',
    unit: 'product',
    icon: serviceIcons.BestBuyProductsScraper,
    brand: 'Best Buy',
    categories: ['products']
  },
  decathlon_products: {
    label: 'Decathlon Products Scraper',
    key: 'decathlon-products',
    unit: 'product',
    icon: serviceIcons.DecathlonProductsScraper,
    brand: 'Decathlon',
    categories: ['products']
  },
  uline_products: {
    label: 'Uline Products Scraper',
    key: 'uline-products',
    unit: 'product',
    icon: serviceIcons.UlineProductsScraper,
    brand: 'Uline',
    categories: ['products']
  },
  menards_products: {
    label: 'Menards Products Scraper',
    key: 'menards-products',
    unit: 'product',
    icon: serviceIcons.MenardsProductsScraper,
    brand: 'Menards',
    categories: ['products']
  },
  target_products: {
    label: 'Target Products Scraper',
    key: 'target-products',
    unit: 'product',
    icon: serviceIcons.TargetProductsScraper,
    supportedEnrichmentServices: [],
    output_fields: ['product_url'],
    brand: 'Target',
    categories: ['products']
  },
  napaonline_products: {
    label: 'NapaOnline Products Scraper',
    key: 'naponline-products',
    unit: 'product',
    icon: serviceIcons.NapaOnlineProductsScraper,
    brand: 'NapaOnline',
    categories: ['products']
  },
  groupon_products: {
    label: 'Groupon Products Scraper',
    key: 'groupon-products',
    unit: 'product',
    icon: serviceIcons.GrouponProductsScraper,
    brand: 'Groupon',
    categories: ['products']
  },
  ipinfo: {
    label: 'IPInfo Scraper',
    key: 'ipinfo',
    unit: 'search',
    icon: serviceIcons.IPInfoScraper,
    input_fields: ['ip', 'ip_address'],
    brand: 'IPInfo',
    categories: ['domainWeb']
  },
  gemplers_products: {
    label: 'Gemplers Products Scraper',
    key: 'gemplers-products', unit: 'product',
    icon: serviceIcons.GemplersProductsScraper,
    brand: 'Gemplers',
    categories: ['products']
  },
  autozone_products: {
    label: 'AutoZone Products Scraper',
    key: 'autozone-products',
    description: 'Returns product listings',
    unit: 'product',
    input_fields: [],
    output_fields: [],
    groups: ['other'],
    icon: serviceIcons.AutozoneProductsScraper,
    brand: 'AutoZone',
    categories: ['products']
  },
  ferguson_products: {
    label: 'Ferguson Products Scraper',
    key: 'ferguson-products',
    description: 'Returns product listings',
    unit: 'product',
    input_fields: [],
    output_fields: [],
    groups: ['other'],
    icon: serviceIcons.FergusonProductsScraper,
    brand: 'Ferguson',
    categories: ['products']
  },
  globalindustrial_products: {
    label: 'GlobalIndustrial Products Scraper',
    key: 'globalindustrial-products',
    description: 'Returns product listings',
    unit: 'product',
    input_fields: [],
    output_fields: [],
    groups: ['other'],
    icon: serviceIcons.GlobalIndustrialProductsScraper,
    brand: 'GlobalIndustrial',
    categories: ['products']
  },
  northerntool_products: {
    label: 'Northerntool Products Scraper',
    key: 'northerntool-products',
    description: 'Returns product listings',
    unit: 'product',
    input_fields: [],
    output_fields: [],
    groups: ['other'],
    icon: serviceIcons.NortherntoolProductsScraper,
    brand: 'Northern Tool',
    categories: ['products']
  },
  wbmason_products: {
    label: 'Wbmason Products Scraper',
    key: 'wbmason-products',
    unit: 'product',
    icon: serviceIcons.WbmasonProductsScraper,
    brand: 'Wbmason',
    categories: ['products']
  },
  booking_search_service: {
    label: 'Booking Search Scraper',
    key: 'booking-search',
    queriesLabel: SEARCH_URLS_LABEL,
    description: 'Returns search results',
    unit: 'record',
    icon: serviceIcons.BookingSearchScraper,
    supportedEnrichmentServices: [],
    output_fields: ['listing_url', 'name'],
    brand: 'Booking',
    categories: ['pois']
  },
  booking_reviews_service: {
    label: 'Booking Reviews Scraper',
    key: 'booking-reviews',
    description: 'Returns reviews from a list of hotels',
    unit: 'review',
    icon: serviceIcons.BookingReviewsScraper,
    queriesPlaceholder: 'https://www.booking.com/hotel/tr/old-town-point-amp-spa-antalya.html\nold-town-point-amp-spa-antalya',
    input_fields: ['listing_url'],
    brand: 'Booking',
    categories: ['reviews'],
    popularityRank: 9
  },
  booking_reviews_monitoring: {
    label: 'Booking Reviews Monitoring',
    key: 'booking-reviews-monitoring',
    icon: serviceIcons.BookingReviewsMonitoring,
    brand: 'Booking',
    categories: ['reviews']
  },
  bestbuy_reviews: {
    label: 'BestBuy Reviews Scraper',
    key: 'bestbuy-reviews',
    description: 'Returns reviews from a list of Best Buy products',
    unit: 'review',
    icon: serviceIcons.BestBuyReviewsScraper,
    brand: 'Best Buy',
    categories: ['reviews']
  },
  better_business_bureau: {
    label: 'BBB Business Scraper',
    key: 'better-business-bureau',
    description: 'Returns business listings from the Better Business Bureau (BBB).',
    unit: 'business',
    icon: serviceIcons.BBBBusinessScraper,
    brand: 'BBB Business',
    categories: ['pois']
  },
  better_business_bureau_reviews: {
    label: 'BBB Business Reviews Scraper',
    key: 'better-business-bureau-reviews',
    description: 'Returns reviews from a list of businesses',
    unit: 'review',
    icon: null,
    brand: 'BBB Business',
    categories: ['reviews']
  },
  booking_prices_service: {
    label: 'Booking Prices Scraper',
    key: 'booking-prices',
    description: 'Returns prices from a list of hotels',
    unit: 'hotel',
    icon: serviceIcons.BookingPricesScraper,
    brand: 'Booking',
    categories: ['pois']
  },
  bradyindustries_products: {
    label: 'Brady Industries Products Scraper',
    key: 'bradyindustries-products',
    unit: 'product',
    icon: serviceIcons.BradyIndustriesProductsScraper,
    brand: 'Brady Industries',
    categories: ['products']
  },
  reddit_search: {
    label: 'Reddit Search Scraper',
    key: 'reddit-search',
    description: 'Returns search results',
    unit: 'post',
    icon: serviceIcons.RedditSearchScraper,
    brand: 'Reddit',
    categories: ['socialSearch']
  },
  reddit_comments: {
    label: 'Reddit Comments Scraper',
    key: 'reddit-comments',
    description: 'Returns comments',
    unit: 'comment',
    icon: serviceIcons.RedditCommentsScraper,
    brand: 'Reddit',
    categories: ['reviews']
  },
  capterra_reviews: {
    label: 'Capterra Reviews Scraper',
    key: 'capterra-reviews',
    description: 'Returns reviews from a list of pages',
    unit: 'review',
    icon: serviceIcons.CapterraReviewsScraper,
    brand: 'Capterra',
    categories: ['reviews']
  },
  ebay_products: {
    label: 'eBay Products Scraper',
    key: 'ebay-products',
    unit: 'product',
    icon: serviceIcons.EbayProductsScraper,
    brand: 'eBay',
    categories: ['products']
  },
  expedia_search: {
    label: 'Expedia Search Scraper',
    key: 'expedia-search',
    queriesLabel: SEARCH_URLS_LABEL,
    description: 'Returns search results',
    unit: 'record',
    icon: serviceIcons.ExpediaSearchScraper,
    supportedEnrichmentServices: [],
    output_fields: ['listing_url'],
    brand: 'Expedia',
    categories: ['pois']
  },
  expedia_reviews: {
    label: 'Expedia Reviews Scraper',
    key: 'expedia-reviews',
    description: 'Returns reviews from a list of hotels',
    unit: 'review',
    input_fields: ['listing_url'],
    icon: serviceIcons.ExpediaReviewsScraper,
    brand: 'Expedia',
    categories: ['reviews']
  },
  g2_reviews: {
    label: 'G2 Reviews Scraper',
    key: 'g2-reviews',
    description: 'Returns reviews from a list of products',
    unit: 'review',
    icon: serviceIcons.G2ReviewsScraper,
    brand: 'G2',
    categories: ['reviews']
  },
  getapp_reviews: {
    label: 'GetApp Reviews Scraper',
    key: 'getapp-reviews',
    description: 'Returns reviews from a list of apps',
    unit: 'review',
    icon: serviceIcons.GetAppReviewsScraper,
    brand: 'GetApp',
    categories: ['reviews']
  },
  google_maps_service: {
    label: 'Google Maps Data Scraper',
    key: 'googleMaps',
    version: 2,
    description: 'Returns places data from Google Maps',
    unit: 'place',
    icon: serviceIcons.GoogleMapsDataScraper,
    recommendedServices: ['leads_n_contacts'],
    serviceOntologies: ['domain', 'phone', 'place_id'],
    excludedEnrichmentServices: ['company_websites_finder'],
    supportedEnrichmentServices: ['ai_chain_info'],
    brand: 'Google',
    categories: ['pois'],
    popularityRank: 1
  },
  google_maps_reviews_service: {
    label: 'Google Maps Reviews Scraper',
    key: 'googleReviews',
    version: 3,
    description: 'Returns reviews from places on Google Maps',
    unit: 'review',
    icon: serviceIcons.GoogleMapsReviewsScraper,
    queriesPlaceholder: 'Real estate agency, Rome, Italy\nChIJu7bMNFV-54gR-lrHScvPRX4\n0x886916e8bc273979:0x5141fcb11460b226\nhttps://www.google.com/maps/search/restaurants+near+New+York,+NY/@40.7404216,-74.0229033,13z\nhttps://www.google.com/maps/place/?q=place_id:ChIJu7bMNFV-54gR-lrHScvPRX4',
    queriesLabel: <Trans i18nKey='title.gm.queries' components={{ idsLink: <span /> }} />,
    output_fields: GOOGLE_MAPS_REVIEWS_OUTPUT_FIELDS,
    brand: 'Google',
    categories: ['reviews'],
    popularityRank: 2
  },
  google_maps_reviews_monitoring: {
    label: 'Google Maps Reviews Monitoring',
    key: 'google-maps-reviews-monitoring',
    icon: serviceIcons.GoogleMapsReviewsMonitoring,
    brand: 'Google',
    categories: ['reviews']
  },
  google_search_service: {
    label: 'Google Search Scraper',
    key: 'google-search',
    version: 3,
    description: 'Returns search results',
    icon: serviceIcons.GoogleSearchScraper,
    supportedEnrichmentServices: ['domains_service', 'emails_validator_service', 'disposable_email_checker', 'trustpilot_service'],
    brand: 'Google',
    categories: ['domainWeb'],
    popularityRank: 16
  },
  google_places_domain_search_service: {
    label: 'Google Maps Search by Domains',
    key: 'google-places-domain-search',
    description: 'Finds places by domains',
    unit: 'domain',
    icon: serviceIcons.GoogleMapsSearchByDomains,
    serviceOntologies: ['domain', 'phone', 'address'],
    output_fields: GOOGLE_PLACE_DOMAIN_SEARCH_OUTPUT_FIELDS,
    supportedEnrichmentServices: [],
    queriesLabel: DOMAIN_QUERIES_LABEL,
    queriesPlaceholder: DOMAIN_QUERIES_PLACEHOLDER,
    brand: 'Google',
    categories: ['pois', 'domainWeb'],
    popularityRank: 12
  },
  places_search_service: {
    label: 'Places Search Service',
    key: 'places-search',
    description: 'Searches the places database using JSON filters. Enter one filter object per query.',
    unit: 'place',
    queriesLabel: QUERY_LABEL_KEYS.JSON_FILTERS,
    hidden: true,
  },
  google_maps_contributor_reviews_service: {
    label: 'Google Maps Contributor Reviews Scraper',
    key: 'google-maps-contributor-reviews',
    description: 'Returns reviews from a list of profiles',
    unit: 'review',
    icon: serviceIcons.GoogleMapsContributorReviews,
    brand: 'Google',
    categories: ['reviews']
  },
  google_maps_photos_service: {
    label: 'Google Maps Photos Scraper',
    key: 'google-maps-photos',
    version: 3,
    description: 'Returns photos from places on Google Maps',
    unit: 'photo',
    icon: serviceIcons.GoogleMapsPhotosScraper,
    brand: 'Google',
    categories: ['pois'],
    popularityRank: 6
  },
  google_maps_traffic_service: {
    label: 'Google Maps Traffic Scraper',
    key: 'googleTraffic',
    description: 'Returns directions between two points',
    unit: 'request',
    icon: serviceIcons.GoogleMapsTrafficScraper,
    brand: 'Google',
    categories: ['pois']
  },
  google_maps_directory_service: {
    label: 'Google Maps Directory Places',
    key: 'google-directory-places',
    icon: serviceIcons.GoogleMapsDirectoryPlaces,
    supportedEnrichmentServices: ['domains_service', 'emails_validator_service', 'trustpilot_service'],
    brand: 'Google',
    categories: ['pois']
  },
  google_search_news_service: {
    label: 'Google Search News Scraper',
    key: 'google-search-news',
    description: 'Returns news',
    icon: serviceIcons.GoogleSearchNewsScraper,
    brand: 'Google',
    categories: ['socialSearch']
  },
  google_search_images_service: {
    label: 'Google Search Images Scraper',
    key: 'google-search-images',
    version: 2,
    description: 'Returns search results',
    unit: 'image',
    icon: serviceIcons.GoogleSearchImagesScraper,
    brand: 'Google',
    categories: ['socialSearch'],
    popularityRank: 17
  },
  google_search_videos_service: {
    label: 'Google Search Videos Scraper',
    key: 'google-search-videos',
    description: 'Returns search results',
    icon: serviceIcons.GoogleSearchVideosScraper,
    brand: 'Google',
    categories: ['socialSearch']
  },
  google_search_events_service: {
    label: 'Google Search Events Scraper',
    key: 'google-search-events',
    description: 'Returns search results',
    icon: serviceIcons.GoogleSearchEventsScraper,
    brand: 'Google',
    categories: ['socialSearch']
  },
  google_search_jobs_service: {
    label: 'Google Search Jobs',
    key: 'google-search-jobs',
    description: 'Returns search results',
    icon: serviceIcons.GoogleSearchJobs,
    brand: 'Google',
    categories: ['socialSearch']
  },
  google_careers_service: {
    label: 'Google Search Careers',
    key: 'google-careers',
    description: 'Returns search results',
    icon: serviceIcons.GoogleSearchCareers,
    brand: 'Google',
    categories: ['socialSearch']
  },
  google_search_shopping_service: {
    label: 'Google Search Shopping Scraper',
    key: 'google-search-shopping',
    unit: 'product',
    icon: serviceIcons.GoogleSearchShoppingScraper,
    brand: 'Google',
    categories: ['products']
  },
  google_trends: {
    label: 'Google Trends Scraper',
    key: 'google-trends',
    description: 'Returns Google Trends search-interest data for your keywords.',
    unit: 'query',
    icon: serviceIcons.GoogleTrendsScraper,
    brand: 'Google',
    categories: ['socialSearch']
  },
  google_play_reviews_service: {
    label: 'Google Play Reviews Scraper',
    key: 'google-play-reviews',
    description: 'Returns reviews from a list of apps',
    unit: 'review',
    icon: serviceIcons.GooglePlayReviewsScraper,
    queriesPlaceholder: 'https://play.google.com/store/apps/details?id=com.facebook.katana\nhttps://play.google.com/store/movies/details/Titanic_2012_Re_Release?id=4S2Ruqhcz78\nhttps://play.google.com/store/books/details/Leo_Tolstoy_War_and_Peace?id=bTDscs8_1sUC\ncom.skype.raider',
    queriesLabel: QUERY_LABEL_KEYS.APPS_MOVIES_BOOKS_LINKS_OR_IDS,
    brand: 'Google',
    categories: ['reviews']
  },
  google_play_reviews_monitoring: {
    label: 'Google Play Reviews Monitoring',
    key: 'google-play-reviews-monitoring',
    icon: serviceIcons.GooglePlayReviewsMonitoring,
    brand: 'Google',
    categories: ['reviews']
  },
  google_shopping_reviews_service: {
    label: 'Google Shopping Reviews Scraper',
    key: 'google-shopping-reviews',
    description: 'Returns reviews from a list of products',
    unit: 'review',
    icon: serviceIcons.GoogleShoppingReviewsScraper,
    brand: 'Google',
    categories: ['reviews']
  },
  glassdoor_search: {
    label: 'Glassdoor Job Scraper',
    key: 'glassdoor-search',
    queriesLabel: SEARCH_URLS_LABEL,
    description: 'Returns search results',
    unit: 'job',
    icon: serviceIcons.GlassdoorJobScraper,
    supportedEnrichmentServices: [],
    output_fields: ['company_url', 'company_name'],
    brand: 'Glassdoor',
    categories: ['socialSearch']
  },
  glassdoor_reviews_service: {
    label: 'Glassdoor Reviews Scraper',
    key: 'glassdoor-reviews',
    description: 'Returns reviews from a list of companies',
    unit: 'review',
    icon: serviceIcons.GlassdoorReviewsScraper,
    input_fields: ['company_url'],
    brand: 'Glassdoor',
    categories: ['reviews']
  },
  homedepot_reviews: {
    label: 'Home Depot Reviews Scraper',
    key: 'homedepot-reviews',
    description: 'Returns reviews from a list of products',
    unit: 'review',
    icon: serviceIcons.HomeDepotReviewsScraper,
    brand: 'Home Depot',
    categories: ['reviews']
  },
  hotels_search: {
    label: 'Hotels Search Scraper',
    key: 'hotels-search',
    queriesLabel: SEARCH_URLS_LABEL,
    description: 'Returns search results',
    unit: 'record',
    icon: serviceIcons.HotelsSearchScraper,
    brand: 'Hotels',
    categories: ['pois']
  },
  hotels_reviews: {
    label: 'Hotels Reviews Scraper',
    key: 'hotels-reviews',
    description: 'Returns reviews from a list of hotels',
    unit: 'review',
    icon: serviceIcons.HotelsReviewsScraper,
    input_fields: ['listing_url'],
    brand: 'Hotels',
    categories: ['reviews']
  },
  etsy_reviews: {
    label: 'Etsy Reviews Scraper',
    key: 'etsy-reviews',
    description: 'Returns reviews from a list of Etsy products',
    unit: 'review',
    icon: serviceIcons.EtsyReviewsScraper,
    brand: 'Etsy',
    categories: ['reviews']
  },
  etsy_products: {
    label: 'Etsy Products Scraper',
    key: 'etsy-products',
    unit: 'product',
    icon: serviceIcons.EtsyProductsScraper,
    brand: 'Etsy',
    categories: ['products']
  },
  indeed_search: {
    label: 'Indeed Job Scraper',
    key: 'indeed-search',
    queriesLabel: SEARCH_URLS_LABEL,
    description: 'Returns search results',
    unit: 'job',
    icon: serviceIcons.IndeedJobScraper,
    supportedEnrichmentServices: [],
    input_fields: ['indeedCompanyUrl'],
    output_fields: ['indeedCompanyUrl', 'company'],
    brand: 'Indeed',
    categories: ['socialSearch'],
    popularityRank: 18
  },
  indeed_reviews: {
    label: 'Indeed Reviews Scraper',
    key: 'indeed-reviews',
    description: 'Returns reviews from a list of companies',
    unit: 'review',
    icon: serviceIcons.IndeedReviewsScraper,
    input_fields: ['indeedCompanyUrl'],
    brand: 'Indeed',
    categories: ['reviews']
  },
  doordash_search: {
    label: 'Doordash Scraper',
    key: 'doordash-search',
    description: 'Returns restaurant data from DoorDash',
    unit: 'review',
    icon: serviceIcons.DoordashScraper,
    brand: 'DoorDash',
    categories: ['pois']
  },
  macys_products: {
    label: 'Macys Products Scraper',
    key: 'macys-products',
    unit: 'product',
    icon: serviceIcons.MacysProductsScraper,
    brand: 'Macy’s',
    categories: ['products']
  },
  officedepot_products: {
    label: 'Office Depot Products Scraper',
    key: 'officedepot-products',
    unit: 'product',
    icon: serviceIcons.OfficeDepotProductsScraper,
    brand: 'Office Depot',
    categories: ['products']
  },
  staples_products: {
    label: 'Staples Products Scraper',
    key: 'staples-products',
    unit: 'product',
    icon: serviceIcons.StaplesProductsScraper,
    brand: 'Staples',
    categories: ['products']
  },
  costco_products: {
    label: 'Costco Products Scraper',
    key: 'costco-products',
    unit: 'product',
    icon: serviceIcons.CostcoProductsScraper,
    brand: 'Costco',
    categories: ['products']
  },
  webstaurantstore_products: {
    label: 'Webstaurantstore Products Scraper',
    key: 'webstaurantstore-products',
    unit: 'product',
    icon: serviceIcons.WebstaurantstoreProductsScraper,
    brand: 'WebstaurantStore',
    categories: ['products']
  },
  producthunt_reviews: {
    label: 'Product Hunt Reviews Scraper',
    key: 'producthunt-reviews',
    description: 'Returns reviews from a list of pages',
    unit: 'review',
    icon: serviceIcons.ProductHuntReviewsScraper ,
    brand: 'Product Hunt',
    categories: ['reviews']
  },
  pinterest: {
    label: 'Pinterest Board Scraper',
    key: 'pinterest',
    unit: 'image',
    icon: serviceIcons.PinterestBoardScraper,
    brand: 'Pinterest',
    categories: ['socialSearch']
  },
  samsclub_products: {
    label: 'Sams Club Products Scraper',
    key: 'samsclub-products',
    unit: 'product',
    icon: serviceIcons.SamsClubProductsScraper,
    brand: 'Sam’s Club',
    categories: ['products']
  },
  shopee_reviews: {
    label: 'Shopee Reviews Scraper',
    key: 'shopee-reviews',
    description: 'Returns reviews from a list of products',
    unit: 'review',
    icon: serviceIcons.ShopeeReviewsScraper,
    brand: 'Shopee',
    categories: ['reviews']
  },
  shopify_products: {
    label: 'Shopify Products Scraper',
    key: 'shopify-products',
    description: 'Returns products from Shopify websites',
    unit: 'product',
    icon: serviceIcons.ShopifyProductsScraper,
    brand: 'Shopify',
    categories: ['products']
  },
  shopify_apps: {
    label: 'Shopify Apps Scraper',
    key: 'shopify-apps',
    unit: 'search',
    icon: serviceIcons.ShopifyAppsScraper,
    brand: 'Shopify',
    categories: ['socialSearch']
  },
  target_reviews: {
    label: 'Target Reviews Scraper',
    key: 'target-reviews',
    description: 'Returns reviews from a list of products',
    unit: 'review',
    icon: serviceIcons.TargetReviewsScraper,
    brand: 'Target',
    categories: ['reviews']
  },
  boots_products: {
    label: 'Boots Products Scraper',
    key: 'boots-products',
    unit: 'product',
    icon: serviceIcons.BootsProductsScraper,
    brand: 'Boots',
    categories: ['products']
  },
  tesco_products: {
    label: 'Tesco Products Scraper',
    key: 'tesco-products',
    unit: 'product',
    icon: serviceIcons.TescoProductsScraper,
    brand: 'Tesco',
    categories: ['products']
  },
  walmart_products: {
    label: 'Walmart Products Scraper',
    key: 'walmart-products',
    unit: 'product',
    icon: serviceIcons.WalmartProductsScraper,
    supportedEnrichmentServices: [],
    output_fields: ['product_url'],
    brand: 'Walmart',
    categories: ['products']
  },
  tiktok_products: {
    label: 'TikTok Products Scraper',
    key: 'tiktok-products',
    unit: 'product',
    icon: serviceIcons.TikTokProductsScraper,
    brand: 'TikTok',
    categories: ['products']
  },
  zoro_products: {
    label: 'Zoro Products Scraper',
    key: 'zoro-products',
    unit: 'product',
    icon: serviceIcons.ZoroProductsScraper,
    brand: 'Zoro',
    categories: ['products']
  },
  lowes_products: {
    label: 'Lowes Products Scraper',
    key: 'lowes-products',
    unit: 'product',
    icon: serviceIcons.LowesProductsScraper,
    brand: 'Lowe’s',
    categories: ['products']
  },
  zalando_products: {
    label: 'Zalando Products Scraper',
    key: 'zalando-products',
    unit: 'product',
    icon: serviceIcons.ZalandoProductsScraper,
    brand: 'Zalando',
    categories: ['products']
  },
  grainger_products: {
    label: 'Grainger Products Scraper',
    key: 'grainger-products',
    unit: 'product',
    icon: serviceIcons.GraingerProductsScraper,
    brand: 'Grainger',
    categories: ['products']
  },
  tiktok_profiles: {
    label: 'TikTok Profiles Scraper',
    key: 'tiktok-profiles',
    description: PROFILE_DESCRIPTION,
    unit: 'page',
    icon: serviceIcons.TikTokProfilesScraper,
    queriesPlaceholder: USERNAMES_OR_PAGES_URLS_LABEL,
    brand: 'TikTok',
    categories: ['socialSearch']
  },
  tripadvisor_search: {
    label: 'Tripadvisor Search Scraper',
    key: 'tripadvisor-search',
    description: 'Returns data from Tripadvisor',
    unit: 'place',
    icon: serviceIcons.TripadvisorSearchScraper,
    supportedEnrichmentServices: [],
    output_fields: ['listing_url'],
    brand: 'Tripadvisor',
    categories: ['pois']
  },
  tripadvisor_reviews_service: {
    label: 'Tripadvisor Reviews Scraper',
    key: 'tripadvisor-reviews',
    version: 3,
    description: 'Returns reviews from a list of businesses',
    unit: 'review',
    icon: serviceIcons.TripadvisorReviewsScraper,
    input_fields: ['listing_url'],
    queriesPlaceholder: 'https://www.tripadvisor.com/Restaurant_Review-g187147-d12947099-Reviews-Mayfair_Garden-Paris_Ile_de_France.html\nhttps://www.tripadvisor.com/Hotel_Review-g187147-d188729-Reviews-or40-Le_Bristol_Paris-Paris_Ile_de_France.html',
    brand: 'Tripadvisor',
    categories: ['reviews'],
    popularityRank: 15
  },
  tripadvisor_reviews_monitoring: {
    label: 'Tripadvisor Reviews Monitoring',
    key: 'tripadvisor-reviews-monitoring',
    icon: serviceIcons.TripadvisorReviewsMonitoring,
    brand: 'Tripadvisor',
    categories: ['reviews']
  },
  trustpilot_reviews_service: {
    label: 'Trustpilot Reviews Scraper',
    key: 'trustpilot-reviews',
    description: 'Returns reviews from a list of businesses',
    unit: 'review',
    input_fields: DOMAIN_INPUT_FIELDS,
    icon: serviceIcons.TrustpilotReviewsScraper,
    queriesPlaceholder: `https://www.trustpilot.com/review/${homeUrl}\n${homeUrl}`,
    queriesLabel: QUERY_LABEL_KEYS.URLS_TO_COMPANY_PROFILES_COMPANY_IDS,
    brand: 'Trustpilot',
    categories: ['reviews'],
    popularityRank: 11
  },
  trustpilot_reviews_monitoring: {
    label: 'Trustpilot Reviews Monitoring',
    key: 'trustpilot-reviews-monitoring',
    icon: serviceIcons.TrustpilotReviewsMonitoring,
    brand: 'Trustpilot',
    categories: ['reviews']
  },
  twitter_profiles: {
    label: 'Twitter Profiles Scraper',
    key: 'twitter-profiles',
    description: PROFILE_DESCRIPTION,
    unit: 'page',
    icon: serviceIcons.TwitterProfilesScraper,
    queriesPlaceholder: USERNAMES_OR_PAGES_URLS_LABEL,
    brand: 'Twitter',
    categories: ['socialSearch']
  },
  walmart_reviews: {
    label: 'Walmart Reviews Scraper',
    key: 'walmart-reviews',
    description: 'Returns reviews from a list of products',
    unit: 'review',
    icon: serviceIcons.WalmartReviewsScraper,
    brand: 'Walmart',
    categories: ['reviews']
  },
  youtube_comments_service: {
    label: 'YouTube Comments Scraper',
    key: 'youtube-comments',
    description: 'Returns comments',
    unit: 'page',
    input_fields: ['video_url', 'video_id'],
    icon: serviceIcons.YouTubeCommentsScraper,
    brand: 'YouTube',
    categories: ['reviews']
  },
  quill_products: {
    label: 'Quill Products Scraper',
    key: 'quill-products',
    queriesLabel: PRODUCT_OR_SEARCH_URLS_LABEL,
    icon: serviceIcons.QuillProductsScraper,
    brand: 'Quill',
    categories: ['products']
  },
  lyreco_products: {
    label: 'Lyreco Products Scraper',
    key: 'lyreco-products',
    queriesLabel: PRODUCT_OR_SEARCH_URLS_LABEL,
    unit: 'product',
    icon: serviceIcons.LyrecoProductsScraper,
    brand: 'Lyreco',
    categories: ['products']
  },
  customink_products: {
    label: 'Customink Products Scraper',
    key: 'customink-products',
    unit: 'product',
    icon: serviceIcons.CustominkProductsScraper,
    brand: 'Custom Ink',
    categories: ['products']
  },
  iteminfo_products: {
    label: 'ItemInfo Products Scraper',
    key: 'iteminfo-products',
    unit: 'product',
    icon: serviceIcons.ItemInfoProductsScraper,
    brand: 'ItemInfo',
    categories: ['products']
  },
  fastenal_products: {
    label: 'Fastenal Products Scraper',
    key: 'fastenal-products',
    unit: 'product',
    icon: serviceIcons.FastenalProductsScraper,
    brand: 'Fastenal',
    categories: ['products']
  },
  youtube_search_service: {
    label: 'YouTube Search Scraper',
    key: 'youtube-search',
    unit: 'search',
    icon: serviceIcons.YouTubeSearchScraper,
    supportedEnrichmentServices: [],
    output_fields: ['channel_url', 'video_url'],
    brand: 'YouTube',
    categories: ['socialSearch']
  },
  youtube_videos: {
    label: 'YouTube Video Scraper',
    key: 'youtube-videos',
    unit: 'video',
    icon: serviceIcons.YouTubeVideoScraper,
    brand: 'YouTube',
    categories: ['socialSearch']
  },
  vrbo_search: {
    label: 'Vrbo Search Scraper',
    key: 'vrbo-search',
    unit: 'search',
    icon: serviceIcons.VrboSearchScraper,
    brand: 'Vrbo',
    categories: ['pois']
  },
  yellowpages_service: {
    label: 'Yellow Pages Search Scraper',
    key: 'yellowpages',
    description: 'Export Yellow Pages businesses with names, categories, addresses, phones, websites, and more',
    unit: 'biz',
    input_fields: [],
    output_fields: ['name', 'categories', 'position', 'years_in_business', 'years_with_yp', 'amenities', 'phone', 'street', 'locality', 'website', 'snippet', 'thumbnail', 'range', 'business_link'],
    output_ontologies: ['domain', 'phone'],
    groups: ['other'],
    icon: serviceIcons.YellowPagesSearchScraper,
    supportedEnrichmentServices: [],
    brand: 'Yellow Pages',
    categories: ['pois'],
    popularityRank: 8
  },
  baidu_maps: {
    label: 'Baidu Maps Scraper',
    key: 'baidu-maps',
    description: BIZ_DESCRIPTION,
    unit: 'biz',
    input_fields: [],
    output_fields: ['id', 'name', 'address', 'rating', 'phones', 'wechat_account_id', 'wechat_account_name', 'wechat_create_time', 'wechat_unique_id', 'wechat_pic_url', 'tag', 'business_time', 'image'],
    output_ontologies: [],
    groups: ['other'],
    icon: serviceIcons.BaiduMapsScraper,
    supportedEnrichmentServices: [],
    brand: 'Baidu',
    categories: ['pois']
  },
  yelp_service: {
    label: 'Y.E.L.P Businesses Scraper',
    key: 'yelp',
    description: 'Returns data from a list of businesses',
    unit: 'business',
    icon: serviceIcons.YelpBusinessesScraper,
    serviceOntologies: ['domain', 'phone', 'address'],
    output_fields: ['biz_id', 'name', 'price_range', 'rating', 'reviews', 'categories', 'neighborhoods', 'phone', 'website', 'latitude', 'longitude', 'city', 'state', 'country', 'business_url', 'services', 'photo', 'tags', 'snippet'],
    supportedEnrichmentServices: [],
    brand: 'Y.E.L.P',
    categories: ['pois']
  },
  yelp_reviews_service: {
    label: 'Y.E.L.P Reviews Scraper',
    key: 'yelp-reviews',
    description: 'Returns reviews from a list of businesses',
    unit: 'review',
    icon: serviceIcons.YelpReviewsScraper,
    input_fields: ['business_url', 'biz_id'],
    output_fields: ['business_url', 'biz_id'],
    supportedEnrichmentServices: [],
    brand: 'Y.E.L.P',
    categories: ['reviews'],
    popularityRank: 13
  },
  yelp_photos: {
    label: 'Y.E.L.P Photos Scraper',
    key: 'yelp-photos',
    description: 'Returns photos from a list of businesses',
    unit: 'photo',
    icon: serviceIcons.YelpPhotosScraper,
    brand: 'Y.E.L.P',
    categories: ['pois']
  },
  zillow_search_service: {
    label: 'Zillow Search Scraper',
    key: 'zillow-search',
    description: 'Returns data from Zillow',
    unit: 'listing',
    icon: serviceIcons.ZillowSearchScraper,
    supportedEnrichmentServices: ['whitepages_addresses', 'fastbackgroundcheck_addresses'],
    brand: 'Zillow',
    categories: ['pois']
  },
  zillow_reviews: {
    label: 'Zillow Reviews Scraper',
    key: 'zillow-reviews',
    description: 'Returns reviews from Zillow agent profiles',
    unit: 'review',
    input_fields: ['agent_profile_url', 'agent_profile_encoded_z_uid'],
    output_fields: ['review_text', 'rating', 'reviewer_name', 'review_date', 'agent_name', 'agent_profile_url'],
    groups: ['other'],
    icon: serviceIcons.ZillowReviewsScraper,
    brand: 'Zillow',
    categories: ['reviews']
  },
  zillow_agents: {
    label: 'Zillow Agents Scraper',
    key: 'zillow-agents',
    description: 'Returns data from Zillow agent profiles',
    unit: 'agent',
    input_fields: ['agent_profile_url'],
    output_fields: ['agent_name', 'agent_title', 'agent_phone', 'agent_email', 'agent_bio', 'agent_rating', 'agent_reviews_count', 'agent_profile_url'],
    groups: ['other'],
    icon: serviceIcons.ZillowAgentsScraper,
    brand: 'Zillow',
    categories: ['pois']
  },
  zillow_transactions: {
    label: 'Zillow Transactions Scraper',
    key: 'zillow-transactions',
    description: 'Returns transaction data from Zillow agent profiles',
    unit: 'transaction',
    input_fields: ['agent_profile_url', 'agent_profile_encoded_z_uid'],
    output_fields: ['transaction_date', 'property_address', 'sale_price', 'property_type', 'agent_name', 'agent_profile_url'],
    groups: ['other'],
    icon: serviceIcons.ZillowTransactionsScraper,
    brand: 'Zillow',
    categories: ['pois']
  },
  business_directory_service: {
    label: 'Business Directory',
    key: 'https://targetron.com/b2b-local-leads-directory/',
    icon: serviceIcons.BusinessDirectory,
    hidden: true
  },
  email_finder_service: {
    label: 'Email Addresses Finder',
    key: 'email-finder',
    description: 'Finds professional emails by names',
    unit: 'email',
    input_fields: ['full name', 'first name', 'family name', 'domain', 'website'],
    icon: serviceIcons.EmailAddressesFinder,
    brand: 'Multi-source',
    categories: ['contactLeads']
  },
  hubspot_contact_emails_enricher_service: {
    label: 'HubSpot Contact Emails Finder',
    key: 'hubspot-contact-emails-finder',
    description: 'Enrich contacts with their email addresses',
    unit: 'email',
    icon: serviceIcons.HubSpotContactEmailsFinder,
    brand: 'Multi-source',
    categories: ['contactLeads']
  },
  hubspot_contact_finder_service: {
    label: 'HubSpot Company Contacts Finder',
    key: 'hubspot-company-contacts-finder',
    description: 'Find company contacts',
    unit: 'email',
    icon: serviceIcons.HubSpotCompanyContactsFinder,
    brand: 'Multi-source',
    categories: ['contactLeads']
  },
  ai_scraper_service: {
    label: 'Universal AI-Powered Scraper',
    key: 'universal-scraper',
    version: 2,
    description: 'Returns the data you need from any web page by using AI',
    unit: 'page',
    icon: serviceIcons.UniversalAIPoweredScraper,
    brand: 'Multi-source',
    categories: ['domainWeb']
  },
  whatsapp_checker_service: {
    label: 'WhatsApp Checker',
    key: 'whatsapp-checker',
    icon: serviceIcons.WhatsAppChecker,
    brand: 'Bing',
    categories: ['contactLeads'],
    hidden: true,
  },
  bing_places: {
    label: 'Bing Maps Scraper',
    key: 'bing-maps',
    description: 'Returns search results',
    unit: 'place',
    icon: serviceIcons.BingMapsScraper,
    serviceOntologies: ['domain', 'phone', 'address'],
    supportedEnrichmentServices: [],
    brand: 'Bing',
    categories: ['pois'],
  },
  streeteasy: {
    label: 'StreetEasy Scraper',
    key: 'streeteasy',
    queriesLabel: SEARCH_URLS_LABEL,
    description: 'Returns real estate listings from StreetEasy.com',
    unit: 'listing',
    input_fields: ['streeteasy_url', 'search_url'],
    output_fields: ['address', 'price', 'bedrooms', 'bathrooms', 'sqft', 'listing_type', 'description', 'amenities', 'contact_info'],
    groups: ['other'],
    icon: serviceIcons.StreetEasyListingsScraper,
    supportedEnrichmentServices: [],
    brand: 'StreetEasy',
    categories: ['pois'],
  },
  uber_eats: {
    label: 'Uber Eats Scraper',
    key: 'uber-eats',
    icon: serviceIcons.UberEatsScraper,
    brand: 'Uber',
    categories: ['pois'],
  },
  deliveroo: {
    label: 'Deliveroo Scraper',
    key: 'deliveroo',
    icon: serviceIcons.DeliverooScraper,
    brand: 'Deliveroo',
    categories: ['pois'],
  },
  deliveroo_reviews: {
    label: 'Deliveroo Reviews Scraper',
    key: 'deliveroo-reviews',
    unit: 'review',
    icon: serviceIcons.DeliverooReviewsScraper,
    brand: 'Deliveroo',
    categories: ['reviews'],
  },
  zoominfo: {
    label: 'Zoominfo Scraper',
    key: 'zoominfo',
    icon: serviceIcons.ZoominfoScraper,
    brand: 'ZoomInfo',
    categories: ['pois'],
  },
  crunchbase_search: {
    label: 'Crunchbase Search Scraper',
    key: 'crunchbase-search',
    queriesLabel: SEARCH_QUERIES_OR_URLS_LABEL,
    icon: serviceIcons.CrunchbaseSearchScraper,
    brand: 'Crunchbase',
    categories: ['pois'],
  },
  crunchbase: {
    label: 'Crunchbase Scraper',
    key: 'crunchbase',
    unit: 'listing',
    icon: serviceIcons.CrunchbaseScraper,
    brand: 'Crunchbase',
    categories: ['pois'],
  },
  olx: {
    label: 'OLX Scraper',
    key: 'olx',
    queriesLabel: SEARCH_URLS_LABEL,
    unit: 'listing',
    icon: serviceIcons.OLXScraper,
    brand: 'OLX',
    categories: ['products'],
  },
  apollo: {
    label: 'Apollo Scraper',
    key: 'apollo',
    unit: 'business',
    icon: serviceIcons.ApolloScraper,
    brand: 'Apollo',
    categories: ['pois'],
    hasServiceIssue: true,
  },
  feedbackcompany: {
    label: 'Feedback Company Scraper',
    key: 'feedbackcompany',
    icon: serviceIcons.FeedbackCompanyScraper,
    brand: 'Feedback Company',
    categories: ['pois'],
  },
  feedbackcompany_reviews: {
    label: 'Feedback Company Reviews Scraper',
    key: 'feedbackcompany-reviews',
    icon: serviceIcons.FeedbackCompanyReviewsScraper,
    brand: 'Feedback Company',
    categories: ['reviews'],
  },
  youtube_transcripts: {
    label: 'YouTube Transcripts Scraper',
    key: 'youtube-transcripts',
    description: 'Returns full text transcripts from any YouTube video',
    icon: serviceIcons.YouTubeTranscriptsScraper,
    brand: 'YouTube',
    categories: ['socialSearch'],
  },
  willhaben: {
    label: 'Willhaben Scraper',
    key: 'willhaben',
    queriesLabel: LISTING_OR_SEARCH_URLS_LABEL,
    icon: serviceIcons.WillhabenScraper,
    brand: 'Willhaben',
    categories: ['products'],
  },
  mobilede: {
    label: 'Mobilede Scraper',
    key: 'mobilede',
    queriesLabel: SEARCH_URLS_LABEL,
    icon: serviceIcons.MobiledeScraper,
    brand: 'mobile.de',
    categories: ['products'],
  },
  immowelt: {
    label: 'Immowelt Scraper',
    key: 'immowelt',
    queriesLabel: SEARCH_URLS_LABEL,
    icon: serviceIcons.ImmoweltScraper,
    brand: 'Immowelt',
    categories: ['products'],
  },
  allegro: {
    label: 'Allegro Scraper',
    key: 'allegro',
    queriesLabel: LISTING_OR_SEARCH_URLS_LABEL,
    icon: serviceIcons.AllegroScraper,
    brand: 'Allegro',
    categories: ['products'],
  },
  craigslist: {
    label: 'Craigslist Scraper',
    key: 'craigslist',
    queriesLabel: LISTING_OR_SEARCH_URLS_LABEL,
    icon: serviceIcons.CraigslistScraper,
    brand: 'Craigslist',
    categories: ['products'],
  },
  '1688_search': {
    label: '1688 Search Scraper',
    key: '1688-search',
    queriesLabel: SEARCH_URLS_LABEL,
    icon: serviceIcons.Search1688Scraper,
    brand: '1688 Search',
    categories: ['socialSearch'],
  },
  glassdoor_company_jobs: {
    label: 'Glassdoor Company Jobs',
    key: 'glassdoor-company-jobs',
    icon: serviceIcons.GlassdoorCompanyJobs,
    brand: 'Glassdoor',
    categories: ['socialSearch'],
  },
  upwork_jobs: {
    label: 'Upwork Jobs',
    key: 'upwork-jobs',
    queriesLabel: SEARCH_URLS_LABEL,
    icon: serviceIcons.UpworkJobs,
    brand: 'Upwork',
    categories: ['socialSearch'],
  },
  offerup: {
    label: 'Offerup Scraper',
    key: 'offerup',
    queriesLabel: PRODUCT_OR_SEARCH_URLS_LABEL,
    icon: serviceIcons.OfferupScraper,
    brand: 'OfferUp',
    categories: ['products'],
  },
  angi: {
    label: 'Angi Scraper',
    key: 'angi',
    queriesLabel: LISTING_OR_SEARCH_URLS_LABEL,
    icon: serviceIcons.AngiScraper,
    brand: 'Angi',
    categories: ['pois'],
  },
  feefo_reviews: {
    label: 'Feefo Reviews Scraper',
    key: 'feefo-reviews',
    queriesLabel: QUERY_LABEL_KEYS.COMPANY_URLS,
    icon: serviceIcons.FeefoReviewsScraper,
    brand: 'Feefo',
    categories: ['reviews'],
  },
  thuisbezorgd_reviews: {
    label: 'Thuisbezorgd Reviews Scraper',
    key: 'thuisbezorgd-reviews',
    queriesLabel: QUERY_LABEL_KEYS.RESTAURANT_IDS_OR_URLS,
    icon: serviceIcons.ThuisbezorgdReviewsScraper ,
    brand: 'Thuisbezorgd',
    categories: ['reviews'],
  },
  producthunt_profiles: {
    label: 'Product Hunt Profiles Scraper',
    key: 'producthunt-profiles',
    description: PROFILE_DESCRIPTION,
    unit: 'page',
    queriesLabel: USERNAMES_OR_PAGES_URLS_LABEL,
    icon: serviceIcons.ProductHuntProfilesScraper,
    brand: 'Product Hunt',
    categories: ['socialSearch'],
  },
  kununu_reviews: {
    label: 'Kununu Reviews Scraper',
    key: 'kununu-reviews',
    queriesLabel: QUERY_LABEL_KEYS.COMPANY_NAMES_OR_URLS,
    icon: null,
    brand: 'Kununu',
    categories: ['reviews'],
  },
  ai_scraper: {
    label: 'AI Scraper',
    key: 'ai-scraper',
    version: 3,
    description: 'Returns the data you need from any web page by using AI',
    icon: serviceIcons.UniversalAIPoweredScraper,
    brand: 'AI'
  },
  contacts_finder_service: {
    label: 'Contacts Finder',
    key: 'contacts-finder',
    hidden: true,
  },
};

export const services = ALL_SERVICES_INCLUDED
  ? SERVICES_DATA
  : Object.fromEntries(
    Object.entries(SERVICES_DATA)
      .filter(([key]) => INCLUDED_SERVICES.has(key))
      .map(([key, service]) => {
        const validIncompatibles = (service.incompatible_with || []).filter(incompatibleKey => INCLUDED_SERVICES.has(incompatibleKey));
        const newService = validIncompatibles.length > 0 ? { ...service, incompatible_with: validIncompatibles } : { ...service };

        if (validIncompatibles.length === 0) {
          const { incompatible_with, ...rest } = newService;
          return [key, rest];
        }

        return [key, newService];
      })
  );

const usedGroups = new Set(Object.values(services).flatMap(service => service.groups));

export const serviceGroups = ALL_SERVICES_INCLUDED ? allServiceGroups : Object.fromEntries(Object.entries(allServiceGroups).filter(([groupKey]) => usedGroups.has(groupKey)));

export const localizeServiceGroupLabel = (t, groupKey, fallbackLabel = groupKey) => {
  switch (groupKey) {
  case 'email':
    return t('description.bestForEmail');
  case 'phone':
    return t('description.bestForPhone');
  case 'analytics':
    return t('description.bestForAnalytics');
  case 'other':
    return t('description.bestForOther');
  default:
    return fallbackLabel;
  }
};

export {
  localizeServiceTitle as localizeEnrichmentServiceTitle,
  localizeServiceTitle as localizeEnrichmentHostServiceTitle,
  localizeServiceDescription as localizeEnrichmentServiceDescription,
} from './serviceLocalization';

export const localizeServiceQueriesLabel = (t, queriesLabel, fallbackLabel = queriesLabel) => {
  switch (queriesLabel) {
  case QUERY_LABEL_KEYS.APPS_MOVIES_BOOKS_LINKS_OR_IDS:
  case 'Apps, movies, books links or IDs':
    return t('queryLabel.apps_movies_books_links_or_ids');
  case QUERY_LABEL_KEYS.ADDRESSES:
  case 'Addresses':
    return t('queryLabel.addresses');
  case QUERY_LABEL_KEYS.COMPANY_IDS_OR_URLS:
    return t('queryLabel.company_ids_or_urls');
  case QUERY_LABEL_KEYS.COMPANY_NAMES_OR_URLS:
  case 'Company names or URLs':
    return t('queryLabel.company_names_or_urls');
  case QUERY_LABEL_KEYS.COMPANY_URLS:
  case 'Company URLs':
    return t('queryLabel.company_urls');
  case QUERY_LABEL_KEYS.CONTRIBUTOR_IDS_OR_URLS:
    return t('queryLabel.contributor_ids_or_urls');
  case QUERY_LABEL_KEYS.COORDINATES_LATITUDE_LONGITUDE:
  case 'Coordinates (latitude + longitude)':
    return t('queryLabel.coordinates_latitude_longitude');
  case QUERY_LABEL_KEYS.DOMAINS_OR_URLS:
  case 'Domains or URLs':
    return t('queryLabel.domains_or_urls');
  case QUERY_LABEL_KEYS.EMAIL_ADDRESSES:
  case 'Email addresses':
    return t('queryLabel.email_addresses');
  case QUERY_LABEL_KEYS.EVENT_IDS_OR_URLS:
    return t('queryLabel.event_ids_or_urls');
  case QUERY_LABEL_KEYS.FB_PAGE_SEARCH_URLS:
    return t('queryLabel.fb_page_search_urls');
  case QUERY_LABEL_KEYS.FULL_NAME_COMPANY_DOMAIN:
    return t('queryLabel.full_name_company_domain');
  case QUERY_LABEL_KEYS.HASHTAGS_OR_HASHTAG_URLS:
    return t('queryLabel.hashtags_or_hashtag_urls');
  case QUERY_LABEL_KEYS.JSON_FILTERS:
    return t('queryLabel.json_filters');
  case QUERY_LABEL_KEYS.LINKS_TO_GOOGLE_CAREERS_SEARCHES:
  case 'Links to Google Careers searches':
    return t('queryLabel.links_to_google_careers_searches');
  case QUERY_LABEL_KEYS.LINKS_TO_PAGES:
  case 'Links to pages':
    return t('queryLabel.links_to_pages');
  case QUERY_LABEL_KEYS.LINKS_TO_SHOPIFY_WEBSITES:
    return t('queryLabel.links_to_shopify_websites');
  case QUERY_LABEL_KEYS.PHONE_NUMBERS_INTERNATIONAL:
  case 'Phone numbers (international)':
    return t('queryLabel.phone_numbers_international');
  case QUERY_LABEL_KEYS.PRODUCT_ASINS_OR_URLS:
  case 'Product ASINs or URLs':
    return t('queryLabel.product_asins_or_urls');
  case QUERY_LABEL_KEYS.PRODUCT_OR_SEARCH_URLS:
  case 'Product or Search URLs':
    return t('queryLabel.product_or_search_urls');
  case QUERY_LABEL_KEYS.QUERIES_BUSINESS_PROFILE_URLS:
    return t('queryLabel.queries_business_profile_urls');
  case QUERY_LABEL_KEYS.QUERIES_CATEGORY_CITY_OR_ZIP_COUNTRY:
    return t('queryLabel.queries_category_city_or_zip_country');
  case QUERY_LABEL_KEYS.QUERIES_STORE_URLS_OR_IDS:
    return t('queryLabel.queries_store_urls_or_ids');
  case QUERY_LABEL_KEYS.QUERIES_TO_SEARCH:
  case 'Queries to search':
    return t('queryLabel.queries_to_search');
  case QUERY_LABEL_KEYS.RESTAURANT_IDS_OR_URLS:
  case 'Restaurant IDs or URLs':
    return t('queryLabel.restaurant_ids_or_urls');
  case QUERY_LABEL_KEYS.SEARCH_OR_LISTING_URLS:
  case 'Search or listing URLs':
    return t('queryLabel.search_or_listing_urls');
  case QUERY_LABEL_KEYS.SEARCH_QUERIES:
  case 'Search Queries':
  case 'Search queries':
    return t('queryLabel.search_queries');
  case QUERY_LABEL_KEYS.SEARCH_QUERIES_OR_URLS:
  case 'Search Queries or URLs':
    return t('queryLabel.search_queries_or_urls');
  case QUERY_LABEL_KEYS.SEARCH_URLS:
  case 'Search URLs':
    return t('queryLabel.search_urls');
  case QUERY_LABEL_KEYS.URLS:
  case 'URLs':
    return t('queryLabel.urls');
  case QUERY_LABEL_KEYS.URLS_TO_COMPANY_PROFILES_COMPANY_IDS:
  case 'URLs to company profiles, company IDs':
    return t('queryLabel.urls_to_company_profiles_company_ids');
  case QUERY_LABEL_KEYS.URLS_TO_DOORDASH_RESTAURANT_PAGES:
    return t('queryLabel.urls_to_doordash_restaurant_pages');
  case QUERY_LABEL_KEYS.URLS_TO_FB_PAGES_PAGES_IDS:
  case 'URLs to FB pages, pages IDs':
    return t('queryLabel.urls_to_fb_pages_pages_ids');
  case QUERY_LABEL_KEYS.URLS_TO_IG_PAGES_PROFILE_USERNAMES:
    return t('queryLabel.urls_to_ig_pages_profile_usernames');
  case QUERY_LABEL_KEYS.URLS_TO_LINKEDIN_PEOPLE_SEARCH:
    return t('queryLabel.urls_to_linkedin_people_search');
  case QUERY_LABEL_KEYS.URLS_TO_PROFILES_PROFILE_IDS:
    return t('queryLabel.urls_to_profiles_profile_ids');
  case QUERY_LABEL_KEYS.US_PHONE_OR_ADDRESS_WITH_ZIP:
    return t('queryLabel.us_phone_or_address_with_zip');
  case QUERY_LABEL_KEYS.US_PHONE_NUMBERS:
  case 'US phone numbers':
    return t('queryLabel.us_phone_numbers');
  case QUERY_LABEL_KEYS.USERNAMES_OR_PAGES_URLS:
  case 'Usernames or pages URLs':
    return t('queryLabel.usernames_or_pages_urls');
  case QUERY_LABEL_KEYS.VIDEO_IDS_OR_URLS:
    return t('queryLabel.video_ids_or_urls');
  case QUERY_LABEL_KEYS.VIDEO_LINKS_OR_VIDEO_IDS:
    return t('queryLabel.video_links_or_video_ids');
  default:
    return fallbackLabel;
  }
};

export const subTitleMap = {
  product: 'Returns product listings',
  search: 'Returns search results',
};
